
function CheckYearFormatOk($element, min, max) {

    var value = $element.val();

    if (value.length === 0) {
        $element.val('');
    }
    if (value.length === 1) {
        if (!(value === '1' || value === '2')) {
            $element.val('');
        }
    } else if (value.length === 2) {
        if (!(value === '19' || value === '20')) {
            $element.val('');
        }
    } else if (value.length === 4) {
        var v = parseInt(value, 10);

        if (!(v > min && v < max)) {
            $element.val('');
        } else {
            // valid input supplied, update
            return true;
        }
    } else if (value.length > 4) {
        $element.val('');
    }
    return false;
}


function FormatYearFounded(element) {

    var input = $(element);
    var min = input.attr('min');
    var max = input.attr('max');
    var yearFormedValidatedOk = CheckYearFormatOk(input, min - 1, max + 1);

    if (yearFormedValidatedOk) {
        // date validated ok, add to URL if needs be

        window.GuideBrokerListFormStateChange(element);
        return true;
    }
    return false;
}

function OnRangeFilterEvent(elem) {

    if ($(elem).data('filtertype') == 'year-range') {
        FormatYearFounded(elem, true);
    }
}

function FilterBrokers(needFilterUpdate, needSearchBarUpdate) {

    var query = $("#dynamic-query").val();
    if ($("#guide-id").val() != "") {
        if (query.includes("?")) query += "&guide=" + $("#guide-id").val();
        else query += "?guide=" + $("#guide-id").val();
    }
    $("#broker-list-loading").show();
    $.ajax({
        type: 'POST',
        url: filterBrokerListUrl,
        data: { query: query, needFilterUpdate: needFilterUpdate, needSearchBarUpdate: needSearchBarUpdate },
        success: function (res) {
            if (res.Success) {

                if (res.SearchBarUpdated) {
                    $("#broker-list-search-bar-wrapper").html(res.SerchBarView);
                }

                $("#broker-list-search-result-wrapper").html(res.FilteredBrokerListView);

                if (res.FiltersUpdated) {

                    if (window.matchMedia("(max-width: 767px)").matches) { // on mobile view
                        $("#show-guide-filter-dialog-body").html(res.FiltersView);
                    } else {
                        $("#broker-list-filter-wrapper").html(res.FiltersView);
                    }

                    RefreshFilterOptions();
                    triggerSearchColReize();
                    InitializeSupportCryptosFilter();
                    InitializeRangeFilter('.range-filter');
                }

                {
                    window.brokerInfos = res.BrokersSearchInfo;
                    window.geoFilteredBrokerInfos = res.GeoFilteredBrokersInfo;
                    window.itemsFound = res.ItemsFound;
                    window.geoFilteredItemsFound = res.GeoFilteredItemsFound;
                }

                ShowGeoAllowedCompanies();

                UpdateGeofilteredCompaniesAlertInfo();

                InitializeBrokerListScrollableTable();

                InitializeBrokerListCopyableFields();
                $(".tooltip").remove();
                $("#broker-list-search-result-wrapper [data-toggle=tooltip]").tooltip('dispose').tooltip({ boundary: 'window' });
            }
        },
        complete: function () {
            $("#broker-list-loading").hide();
        }
    })
    if (window.location.search != undefined && window.location.search != "")
        $('#broker-search-form > div.head-line > span.filter-reset').show();
    else $('#broker-search-form > div.head-line > span.filter-reset').hide();
}

function LoadMoreBrokers() {

    $('.broker-list-table.clone tr[data-trigger="load-more"]').data("loading", true);
    $("#broker-list-loading").show();

    var targetPage = $('.broker-list-table.clone tr[data-trigger="load-more"]').data("next-page");

    var query = $("#dynamic-query").val();
    if ($("#guide-id").val() != "") {
        if (query.includes("?")) query += "&guide=" + $("#guide-id").val();
        else query += "?guide=" + $("#guide-id").val();
    }
   
    $.ajax({
        type: 'POST',
        url: loadMoreBrokerListUrl,
        data: { query: query, page: targetPage},
        success: function (res) {
            if (res.Success) {
                if (res.HasNextPage) {
                    $('table.broker-list-table tr[data-trigger="load-more"]').data("next-page", res.PageNumber + 1);
                } else {
                    $('.broker-list-table tr[data-trigger="load-more"]').remove();
                }
                $("table.broker-list-table>tbody").append(res.BrokerListRowsContent);

                ShowGeoAllowedCompanies();

                $('.broker-list-table [data-toggle="tooltip"]').tooltip();

                InitializeBrokerListTableShadow();
                InitializePopLabelList();
                LoadBrokerListForumPostsNum();
                window.Site.InitAuthorPopovers();

                initializeThumImagesFallbacks();
            }
        },
        complete: function () {
            $("#broker-list-loading").hide();
            $('.broker-list-table.clone tr[data-trigger="load-more"]').data("loading", false);
        }
    })
    if (window.location.search != undefined && window.location.search != "")
        $('#broker-search-form > div.head-line > span.filter-reset').show();
    else $('#broker-search-form > div.head-line > span.filter-reset').hide();
}
function GuideBrokerListFormStateChange(element, excludeParam, onlyUpdateUrl) {

    var filterForm = $("form#broker-search-form");
    var searchForm = $("form#broker-list-search-bar");

    var query = filterForm.serializeArray().concat(searchForm.serializeArray()).filter(function (i) {

        var elem = $('select[name=' + i.name + ']');

        var e = $('[name=' + i.name + ']');
        if (i.value != "" && i.value != "-1" && i.name !== excludeParam && i.value != e.data('ignore-value')) {
            elem.addClass("active");
            if (i.name == "sort") {
                if (!!elem.attr("sort-dir")) {
                    var sortDir = elem.attr("sort-dir");
                    if ((sortDir == "desc" && !i.value.includes("name")) || (sortDir == "asce" && i.value.includes("name"))) {
                        return i.value;
                    } else {
                        return i.value += "-" + elem.attr("sort-dir");
                    }
                }
            }
            return i.value;
        } else {
            elem.removeClass("active");
        }
    });

    var guideUpdated = false;

    var string = "?";
    $.each(query,
        function (i, v) {
            if (string.includes(v.name + "=")) {

                var splitOne = string.lastIndexOf(v.name + "=");
                var splitTwo = string.substring(splitOne).indexOf("&") + 1;
                splitTwo = splitTwo === 0 ? string.length : splitTwo;

                var currentEntry = string.substring(splitOne, splitTwo);
                var newEntry = currentEntry + "," + v.value;

                string = string.replace(currentEntry, newEntry);

            } else {
                if (string !== "?") {
                    string += "&";
                }
                string += v.name + "=" + v.value;
            }

        });

    string = string.toLowerCase();

    if (string === "?") {
        string = document.location.pathname;
        $('#dynamic-query').val('');
    } else {
        $('#dynamic-query').val(string);

    }

    if (onlyUpdateUrl == true) {
        window.history.pushState("", "", string);
        return true;
    }

    var hasChanged = (window.dynamicState !== string);

    var oldUrlParams = new URLSearchParams(window.location.search);
    var newUrlParams = new URLSearchParams(string);

    var needUpdateFilter = false;
    if (oldUrlParams.get("categories") != newUrlParams.get("categories")) {
        needUpdateFilter = true;
    }

    window.dynamicState = string;

    if (hasChanged && !guideUpdated) {
        window.history.pushState("", "", string);
        FilterBrokers(needUpdateFilter, false);
    }

    return hasChanged;
}
var retries = 0;
function triggerSearchColReize() {
    if (window.BrokerCompare == undefined) {

        retries++;
        if (retries < 10) {
            setTimeout(function () { triggerSearchColReize() }, 300);
        }
    } else {

        window.BrokerCompare.resetSearchColWidth(false);
    }
}

function ResetFilter() {

    window.history.pushState("", "", window.location.pathname);
    $("#dynamic-query").val('');
    $("#show-guide-filter-dialog").modal("hide");
    $("#show-guide-filter-dialog-body").html('');
    FilterBrokers(true, true);
}

function RefreshFilterOptions() {

    // refresh faux multi select
    $('div.faux-multi-select-wrap').append("<div class='selected-options'></div>");

    $("li.trigger-click").each(function (i, e) {

        $option = $(e)
        var $optionVal = $($option.find('input:checkbox'));
        $optionVal.is(':checked') ? $optionVal.prop('checked', false) : $optionVal.prop('checked', true);
        $option.hasClass('active') ? $option.removeClass('active') : $option.addClass('active');


        var $selectorDiv = $(this).closest("div.faux-multi-select-wrap")
            .find("div.faux-multi-select.frn-override");

        var selectedOptionsOutputDiv = $(this).closest("div.faux-multi-select-wrap")
            .find("div.selected-options");
        var selectedOptionsCountDiv = $(this).closest("div.faux-multi-select-wrap")
            .find("span.multi-num");
        var labelText = $optionVal.parent().find('label').text();

        if ($optionVal.is(':checked')) {

            selectedOptionsOutputDiv.append("<div>" + labelText + "<button type='button' class='close' aria-label='Close'><span aria-hidden='true'>×</span></button ></div>");
        } else {

            selectedOptionsOutputDiv.find('div:contains("' + labelText + '")').remove();
        };

        var count = selectedOptionsOutputDiv.children().length;
        if (count > 0) {
            $selectorDiv.addClass("active");

            if (selectedOptionsCountDiv.attr('no-bracket') !== undefined)
                selectedOptionsCountDiv.html(count);
            else selectedOptionsCountDiv.html("(" + count + ")");
        } else {
            $selectorDiv.removeClass("active");
            selectedOptionsCountDiv.html("");
        }

        if ($option.data('callback') !== undefined) {
            var callback = $option.data('callback');
            $("#panel").slideToggle();
            if (typeof callback == "string") {
                window[callback]();
            }
        }

        $optionVal.removeClass('trigger-click');
    });

    if (window.location.search != undefined && window.location.search != "")
        $('#broker-search-form > div.head-line > span.filter-reset').show();
    else $('#broker-search-form > div.head-line > span.filter-reset').hide();
}
function dataFilter(item, query) {
    return (
        item.Name.toLowerCase().indexOf(query) > -1 ||
        item.WebsiteLink.toLowerCase().indexOf(query) > -1 ||
        item.AlternativeWebsites.toLowerCase().indexOf(query) > -1
    );
};
function displayValue(item) {
    return item.Name;
}
function RefreshSearchBarOptions() {    
    if ($("#broker-search-input").parent().find('ul'))
        $("#broker-search-input").parent().find('ul').remove();

    var brokerListForSearch = [];
    if (!window.availableBrokerInfos || !Array.isArray(window.availableBrokerInfos)) {        
        var e = document.querySelectorAll("td[data-broker-name] a span");
        var websiteLink = document.querySelectorAll("td[data-broker-websitelink]");
        var altenativeWebsites = document.querySelectorAll("td[data-broker-alternativewebsites]");
        for (var i = 0; i < e.length; i++) {
            brokerListForSearch.push({
                Name: $(e[i]).text(),
                WebsiteLink: $(websiteLink[i]).text(),
                AlternativeWebsites: $(altenativeWebsites[i]).text(),
            });
        }
    } else {
        brokerListForSearch = window.availableBrokerInfos;
    }
    if (brokerListForSearch.length > 0) {
        $("#broker-search-input").custom_autocomplete({
            data: brokerListForSearch,
            filter: dataFilter,
            displayValue: displayValue
        });
    }
}

function InitializeImages() {

    var images = $('.article-body img:not(.lightbox-image)');
    for (var i = 0; i < images.length; i++) {
        if ($(images[i]).parent().is('a')) continue;

        if (images[i].naturalWidth > $('.article-body').width()) {
            var srcLink = $(images[i]).attr('src');
            $(images[i]).wrap('<a href="' + srcLink + '" data-toggle="article-lightbox-image" data-target-id="article-lightbox-image-holder">');
        }
    }

    $('[data-toggle="article-lightbox-image"]').on('click', function (e) {

        e.preventDefault();
        var id = $(this).data("target-id");;
        var srclink = $(this).attr('href');
        $('#' + id + " img.lightbox-image").attr('src', srclink);
        setTimeout(function () {
            $('#' + id).modal('show');
        }, 100);
        return false;
    });
}
function InitializeRealTimeFilter() {

    $(document).on('input', 'input[data-trigger="realtime-filter"]', function () {

        var that = this;
        var value = $(this).val().toLowerCase();

        if ($(this).data("lastval") != value) {

            $(this).data("lastval", value);

            if (window.tid != undefined)
                clearTimeout(window.tid);

            window.tid = setTimeout(function () {
                //your change action goes here
                var targetId = $(that).data('target');

                $('#' + targetId + ' [data-text]').each(function (index, elem) {
                    if (!value || $(elem).data('text').includes(value)) {
                        $(elem).show();
                    } else {
                        $(elem).hide();
                    }
                });
            }, 200);
        };
    });

    $(document).on('click', 'a[data-trigger=coin-cap-filter]', function () {
        var that = this;
        $(that).parent().find('[data-trigger=coin-cap-filter]').removeClass('active');
        var target = $(that).data('target');
        var filter = $(that).data('filter');
        var query = $('input[data-trigger="realtime-filter"][data-target="' + target + '"]').val().toLowerCase();

        if (filter == -1) {
            $("#" + target + " [data-market-cap]").each(function (index, elem) {
                if (!query || $(elem).data('text').includes(query)) {
                    $(elem).show();
                } else {
                    $(elem).hide();
                }
            });
        } else {
            $("#" + target + ' [data-market-cap]:not([data-market-cap=' + filter + '])').hide();
            $("#" + target + ' [data-market-cap = ' + filter + ']').each(function (index, elem) {
                if (!query || $(elem).data('text').includes(query)) {
                    $(elem).show();
                } else {
                    $(elem).hide();
                }
            });
        }
        $(that).addClass('active');
    })
}

function InitializeBrokerListScrollableTable() {

    jQuery(".fixed-column-table").clone(true).appendTo('#fixed-column-table-container').addClass('clone');

    InitialzeTableSort();
    InitializePopLabelList();

    initializeThumImagesFallbacks();
    // $(".fixed-column-table [data-toggle=tooltip]").tooltip();
}

function ShowBrokerListFilter() {

    var searchEle = $('#broker-search').remove();
    searchEle.appendTo('#show-guide-filter-dialog-body');
    $("#exchange-list-cyptos-filter").infiniteselect('refresh');
    $('#show-guide-filter-dialog').modal('show');
}

function InitializePopLabelList() {
    $('[data-toggle="pop-label-list"]').popover('dispose'); // remove old popover if exists
    $('[data-toggle="pop-label-list"]')
        .popover({
            html: true,
            trigger: "manual",
            template: '<div class="popover broker-list-item-more-popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
            content: function () {

                var data = $(this).data('text');
                var out = '<div class="labels-popover-content">' + data + '</div>';

                return out;
            }
        }).on("mouseenter", function () {
            var _this = this;
            $(this).popover("show");
            $(".popover").on("mouseleave", function () {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function () {
            var _this = this;
            setTimeout(function () {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide");
                }
            }, 100);
        });
}

function InitializeSupportCryptosFilter() {

    if ($("#exchange-list-cyptos-filter").length > 0) {
        $("#exchange-list-cyptos-filter").infiniteselect({
            types: [
                { option: '-1', text: 'All' },
                { option: '0', text: 'Major' },
                { option: '1', text: 'Minor' },
                { option: '2', text: 'Exotic' }],
            url: '/api/widgets/cryptos',
            showDescription: false,
            multiSelect: true,
            culture: window.CURRENT_LANG,
            btnClass: '',
            inputClass: 'form-control',
        });
        document.getElementById('exchange-list-cyptos-filter').addEventListener('change', function () {
            GuideBrokerListFormStateChange(this);
        });
    }
}

function InitializeImageLazyLoading() {
    var lazyloadImages;

    if ("IntersectionObserver" in window) {
        lazyloadImages = document.querySelectorAll(".lazy-load");
        var imageObserver = new IntersectionObserver(function (entries, observer) {
            // console.log(observer);
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var image = entry.target;
                    image.src = image.dataset.src;
                    image.classList.remove("lazy-load");
                    imageObserver.unobserve(image);
                }
            });
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.01
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });
    } else {
        var lazyloadThrottleTimeout;
        lazyloadImages = $(".lazy");

        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function () {
                var scrollTop = $(window).scrollTop();
                lazyloadImages.each(function () {
                    var el = $(this);
                    if (el.offset().top < window.innerHeight + scrollTop + 500) {
                        var url = el.attr("data-src");
                        el.attr("src", url);
                        el.removeClass("lazy-load");
                        lazyloadImages = $(".lazy-load");
                    }
                });
                if (lazyloadImages.length == 0) {
                    $(document).off("scroll");
                    $(window).off("resize");
                }
            }, 20);
        }

        $(document).on("scroll", lazyload);
        $(window).on("resize", lazyload);
    }
}
function InitializeBrokerListCopyableFields() {
    $("#broker-list-table td.copyable").on('click', function (e) {
        var text = $(this).find('span').text();
        if (text != '') {
            var textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            if (document.execCommand("copy")) {
                toastr.success(window.CodeCopiedMessage);
            } else {
                toastr.error("Failed to copy code");
            }
            document.body.removeChild(textArea);
        }
    })
}

function ReadBrokerListArticle(e) {
    if ($("#article").length > 0) {
        var height = $("#article")[0].scrollHeight;
        $("#article-accordion").append($("#article #primary").clone(true));
        $("#article-accordion")[0].style.maxHeight = height + "px";
    }
    $("#article").remove();

    e.classList.toggle("active");

    if (e.classList.contains("active")) {
        $(e).html(window.HideArticleString);
        $("#article-accordion").removeClass("ac-hidden");
    } else {
        $(e).html(window.ReadArticleString);
        $("#article-accordion").addClass("ac-hidden");
    }
}

function NeedLoadMore() {

    var $elem = $('.broker-list-table.clone tr[data-trigger="load-more"]');
    if ($elem.length == 0) return false;

    var elementPos = $elem.offset().top;

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    var height = $(window).height();
    return viewportTop < elementPos && elementPos < viewportBottom + height;
}
function LoadBrokerListForumPostsNum() {
    // Find all links with the data-action 'forum-post-link'
    var brokerIds = $('.broker-list-table.clone a[data-action="forum-post-link"]').map(function () {
        // For each link
        // Parse the 'data-broker-id' attribute as an integer
        return parseInt($(this).data('broker-id'), 10);
    }).get(); // Convert the result to a regular array

    if (brokerIds.length == 0) return;

    var dataToSend = {
        entityType: 'BrokerView',
        entityIds: brokerIds
    };

    $.ajax({
        url: '/api/forum/get/entity/ids',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(dataToSend),
        success: function (jsonResponse) {

            var postNumbersLookup = {};
            jsonResponse.topicResponse.PostNumbers.forEach(function (postNumber) {

                postNumbersLookup[postNumber.EntityId] = postNumber.PostCount;
            });
            
            $('.broker-list-table a[data-action="forum-post-link"]').each(function () {
                var link = $(this);
                var brokerId = link.data('broker-id');

                // Check if the brokerId exists in the mapping
                if (postNumbersLookup.hasOwnProperty(brokerId)) {
                    // Update the link's text with the PostCount from the mapping
                    link.text(postNumbersLookup[brokerId]);
                    link.attr('data-action', '');
                }
            });

        },
        error: function (xhr, status, error) {
            console.error('Error posting data: ', error);
            // Handle errors here
        }
    });
}

function InitializeRangeFilter(selector) {

    var filters = document.querySelectorAll(selector);

    filters.forEach(function (filterElement, key) {

        const slider = filterElement.querySelector(".slider");

        const range = filterElement.querySelector(".range");
        const thumbLeft = filterElement.querySelector(".thumb.left");
        const thumbRight = filterElement.querySelector(".thumb.right");

        const fromInput = document.querySelector('input[name=' + slider.getAttribute('data-input-name') + "-min" + ']');
        const toInput = document.querySelector('input[name=' + slider.getAttribute('data-input-name') + "-max" + ']');


        const min = parseFloat(slider.getAttribute('data-min'));
        const max = parseFloat(slider.getAttribute('data-max'));
        var from = min;
        var to = max;

        if (fromInput.value) from = parseFloat(fromInput.value);
        if (toInput.value) to = parseFloat(toInput.value);

        fromInput.setAttribute('data-ignore-value', min);
        toInput.setAttribute('data-ignore-value', max);

        function updateUI() {
            if (min == max) {
                thumbLeft.style.left = '0%';
                thumbRight.style.left = '100%';
                range.style.left = '0%';
                range.style.width = '100%';

                return;
            }
            var percentFrom = ((from - min) / (max - min)) * 100;
            var percentTo = ((to - min) / (max - min)) * 100;

            thumbLeft.style.left = percentFrom + '%';
            thumbRight.style.left = percentTo + '%';
            range.style.left = percentFrom + '%';
            range.style.width = (percentTo - percentFrom) + '%';

            fromInput.value = from;
            toInput.value = to;
        }

        function moveThumb(e, isLeft) {

            if (min == max) return;

            var clientX = e.clientX || e.touches[0].clientX;
            var rect = slider.getBoundingClientRect();
            var percent = ((clientX - rect.left) / rect.width) * 100;

            var value = Math.round(min + ((percent / 100) * (max - min)));

            if (isLeft) {
                from = Math.min(Math.max(min, value), to - 1);
            } else {
                to = Math.max(Math.min(max, value), from + 1);
            }

            updateUI();
        }

        function onMouseMoveLeft(e) {
            moveThumb(e, true);
        }

        function onMouseMoveRight(e) {
            moveThumb(e, false);
        }

        function onMouseUp() {
            document.removeEventListener('mousemove', onMouseMoveLeft);
            document.removeEventListener('mousemove', onMouseMoveRight);
            document.removeEventListener('touchmove', onMouseMoveLeft);
            document.removeEventListener('touchmove', onMouseMoveRight);
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('touchend', onMouseUp);
        }

        thumbLeft.addEventListener("mousedown", function (e) {
            e.preventDefault();
            document.addEventListener('mousemove', onMouseMoveLeft);
            document.addEventListener('mouseup', onMouseUp);
        });

        thumbLeft.addEventListener("touchstart", function (e) {
            e.preventDefault();
            document.addEventListener('touchmove', onMouseMoveLeft);
            document.addEventListener('touchend', onMouseUp);
        });

        thumbRight.addEventListener("mousedown", function (e) {
            e.preventDefault();
            document.addEventListener('mousemove', onMouseMoveRight);
            document.addEventListener('mouseup', onMouseUp);
        });

        thumbRight.addEventListener("touchstart", function (e) {
            e.preventDefault();
            document.addEventListener('touchmove', onMouseMoveRight);
            document.addEventListener('touchend', onMouseUp);
        });

        fromInput.addEventListener('change', function (e) {
            const value = parseFloat(e.target.value);
            if (!isNaN(value)) {
                from = Math.min(Math.max(min, value), to - 1);
                updateUI();
            }
        })
        toInput.addEventListener('change', function (e) {
            const value = parseFloat(e.target.value);
            if (!isNaN(value)) {
                to = Math.max(Math.min(max, value), from + 1);
                updateUI();
            }
        })

        updateUI(); // Initialize positions
    })
}

function OnChangeSymbolGroup() {
    var value = $("#broker-symbols-tab-group-selection").val();

    $('#broker-symbols-table [data-group]').each(function (index, elem) {
        if (!value || $(elem).data('group') == value) {
            $(elem).show();
        } else {
            $(elem).hide();
        }
    });
}


function OnChangeSymbolPlatform() {
    var value = $("#broker-symbols-tab-platform-selection").val();

    $('#broker-symbols-table [data-platform]').each(function (index, elem) {
        if (!value || $(elem).data('platform').includes(value)) {
            $(elem).show();
        } else {
            $(elem).hide();
        }
    });
}

function GetOverallRating() {

    if (window.brokerRatings && window.brokerRatings.OverallRating)
        return window.brokerRatings.OverallRating;

    var rating = $($("#tab-review-box .broker-detail-page-rating-num")[0]).text();
    if ($("[data-action=startup-update][data-key=overall-rating-value]").length > 0)
        rating = $($("[data-action=startup-update][data-key=overall-rating-value]")[0]).text();
    
    return rating;
}

function GetUserRating() {

    if (window.brokerRatings) {
        return window.brokerRatings.UserRating;
    }

    var rating = $($("#tab-user-reviews-box .broker-detail-page-rating-num")[0]).text();

    if ($("[data-action=startup-update][data-key=user-rating-value]").length > 0) {
        rating = $($("[data-action=startup-update][data-key=user-rating-value]")[0]).text();
    }

    return rating;
}


function GetUserReviewCount() {

    if (window.brokerRatings) {
        return window.brokerRatings.UserReviewCount;
    }

    var count = $($("#tab-user-reviews-box .broker-detail-page-rating-stars+a")[0]).text().trim().replaceAll('(', '').replaceAll(')', '');

    if ($("[data-action=startup-update][data-key=user-rating-review-count]").length > 0) {
        count = $($("[data-action=startup-update][data-key=user-rating-review-count]")[0]).text();
    }

    return count;
}

function UpdateBrokerTabSEO(tabId) {

    UpdateBrokerPageHrefs(tabId);

    const brokerName = window.brokerInfo['name'];

    var h1Title = window.brokerSEOStrings[tabId]['h1'].replaceAll('{0}', brokerName);
    $("h1").html(h1Title);

    var pageTitle = window.brokerSEOStrings[tabId]['title'].replaceAll('{0}', brokerName);
    $("title").html(pageTitle);
    $("meta[name=title]").attr('content', pageTitle);

    var metaDesc = window.brokerSEOStrings[tabId]['meta'].replaceAll('{0}', brokerName);
    if (tabId == 'review') {
        var rating = GetOverallRating();

        metaDesc = metaDesc.replaceAll('{1}', RatingValue(rating));

    } else if (tabId == 'user-reviews') {
        var rating = GetUserRating();
        var count = GetUserReviewCount();

        metaDesc = metaDesc.replaceAll('{1}', RatingValue(rating));
        metaDesc = metaDesc.replaceAll('{2}', count);

    } else if (tabId == 'regulation') {
        var cnt = 0;
        if ($("#high-rated-regulator-count").length > 0) cnt = $("#high-rated-regulator-count").val();
        metaDesc = metaDesc.replaceAll('{1}', cnt);
    }

    $("meta[name=description]").attr('content', metaDesc);
    $("#broker-subtext").html(metaDesc);


    /*
    if (tabId == "tab-review") {
        window.schemaTemplate = window.brokerExpertReviewSchemaTemplate;
    } else if (tabId == "tab-rebates" || tabId == "tab-user-reviews") {
        window.schemaTemplate = window.brokerAggregateSchemaTemplate;
    } else {
        window.schemaTemplate = undefined;
    }

    UpdateSchemaTemplate();
    */
}

function UpdateBrokerViewAuthors(targetTab) {

    if (targetTab == 'user-reviews') {
        $('.broker-authors .broker-author').hide();
        $('.broker-authors .broker-author[data-author-role="human-moderator"').show();
    } else if (targetTab == 'rebates' || targetTab == 'review') {
        $('.broker-authors .broker-author').show();
        $('.broker-authors .broker-author[data-author-role="human-moderator"').hide();
    } else {
        $('.broker-authors .broker-author').hide();
    }
}
function GetBrokerSwitchedTabUrl(originalUrl, targetTab) {
    var segements = originalUrl.split('/');
    var brokerId = segements[segements.length - 1];
    var orgTab = segements[segements.length - 2];

    return originalUrl.replace("-" + orgTab + "-" + brokerId, "-" + targetTab + "-" + brokerId);
}

function GetBrokerTabUrl(orginalUrl, tabId, brokerId, urlSlug) {
    var newSlug = urlSlug + "-" + tabId + "-" + brokerId;

    var currentPath = orginalUrl;
    var lastSlashIndex = currentPath.lastIndexOf('/');
    var basePath = currentPath.substring(0, lastSlashIndex + 1);
    var newPath = basePath + newSlug;

    return newPath;
}
function UpdateBrokerPageHrefs(tabId) {

    var newSlug = window.brokerInfo['urlSlug'] + "-" + tabId + "-" + window.brokerInfo['id'];

    // From current url, remove last path segment and add new slug
    var currentPath = window.location.pathname;
    var lastSlashIndex = currentPath.lastIndexOf('/');
    var basePath = currentPath.substring(0, lastSlashIndex + 1);
    var newPath = basePath + newSlug;

    // Update current URL
    if (window.history && window.history.replaceState) {
        var newUrl = window.location.protocol + "//" + window.location.host + newPath;
        window.history.replaceState({}, '', newUrl);
    }

    var newCanonical = '';

    if (window.PORTAL_CODE == "HFT") {
        newCanonical = "https://fxverify.com" + newPath;
    } else {
        newCanonical = window.location.protocol + "//" + window.location.host + newPath;
    }

    if ($("link[rel='canonical']").length > 0) {
        $("link[rel='canonical']").attr('href', newCanonical);
    } else {
        $("head").append("<link rel='canonical' href='" + newCanonical + "' />");
    }
    var hreflangs = $("link[hreflang]");
    for (var i = 0; i < hreflangs.length; i++) {
        hreflangs[i].href = GetBrokerTabUrl(hreflangs[i].href, tabId, window.brokerInfo['id'], window.brokerInfo['urlSlug']);
    }

    var langSelectors = $("#lang-select li a")
    for (var i = 0; i < langSelectors.length; i++) {

        var newLink = GetBrokerTabUrl(langSelectors[i].href, tabId, window.brokerInfo['id'], window.brokerInfo['urlSlug']);

        var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];

        langSelectors[i].href = newLink;
        if (langCode == "en")
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + newLink + "','" + langCode + "')");
        else
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + newLink + "','" + langCode + "')");
    }
}

function OpenCountryAvailabilityDialog() {
    if (!window.brokerCountries) return;

    var html = '';
    for (var i = 0; i < window.brokerCountries.length; i++) {
        var text = window.brokerCountries[i].CountryName + ' - ';
        if (window.brokerCountries[i].Availability == 0) text += window.brokerResxStrings['Unknown'];
        else if (window.brokerCountries[i].Availability == 1) text += window.brokerResxStrings['Accepted'];
        else text += window.brokerResxStrings['NotAccepted'];

        html += '<span>' + text + '</span>';
    }

    $("#broker-countries-dialog-payload").html(html);

    $("#broker-countries-dialog").modal('show');
}

function UpdateRatings(brokerId) {

    $.ajax({
        url: '/' + window.CURRENT_LANG + '/api/brokers/ratings/' + brokerId,
        type: 'POST',
        cache: false,
        async: true,
        success: function (result) {
            window.brokerRatings = result;

            if (result.UserCountryAvailability) {

                window.brokerCountries = result.AllCountries;

                var text;
                if (result.UserCountryAvailability.Availability == 2) { // Not accepted
                    text = window.brokerResxStrings['NotAvailableIn0'].replace("{0}", '<a href="javascript:void(0);" onclick="OpenCountryAvailabilityDialog();">' + result.UserCountryAvailability.CountryName + '</a>');
                    $("#broker-availability").html("<img src='/Content/dist/images/icons/cons-check.svg' /> " + text);
                } else if (result.UserCountryAvailability.Availability == 0) { // Unknown
                    text = window.brokerResxStrings['UnknownAvailabilityIn0'].replace("{0}", '<a href="javascript:void(0);" onclick="OpenCountryAvailabilityDialog();">' + result.UserCountryAvailability.CountryName + '</a>');
                    $("#broker-availability").html("<img src='/Content/dist/images/icons/cons-check.svg' /> " + text);
                } else if (result.UserCountryAvailability.Availability == 1) {
                    text = window.brokerResxStrings['AvailableIn0'].replace("{0}", '<a href="javascript:void(0);" onclick="OpenCountryAvailabilityDialog();">' + result.UserCountryAvailability.CountryName + '</a>');
                    $("#broker-availability").html("<img src='/Content/dist/images/icons/pros-check.svg' /> " + text);
                }

                $("#broker-availability").show();
            }
            if (!window.brokerInfo) return;

            // $("[data-action=startup-update]").html('');

            $("[data-action=startup-update][data-key=overall-rating-value]").html(RatingValue(window.brokerRatings.OverallRating));
            $("[data-action=startup-update][data-key=overall-rating-stars]").html(GetRatingStarsHtml(window.brokerRatings.OverallRating));

            var primaryCategory = window.brokerInfo['primaryCategory'];
            var overallRankDesc = window.brokerResxStrings['Ranked0OutOf12'].replaceAll("{0}", window.brokerRatings.OverallRatingRank)
                .replaceAll("{1}", window.brokerRatings.PrimaryCategoryBrokers)
                .replaceAll("{2}", primaryCategory);
            $("[data-action=startup-update][data-key=overall-rating-rank-description]").html(overallRankDesc);
            $("[data-action=startup-update][data-key=overall-rating-table]").html(GetRatingsTableHtml(window.brokerRatings));


            $("[data-action=startup-update][data-key=user-rating-value]").html(RatingValue(window.brokerRatings.UserRating));
            $("[data-action=startup-update][data-key=user-rating-stars]").html(GetRatingStarsHtml(window.brokerRatings.UserRating));

            $("[data-action=startup-update][data-key=user-rating-stars]").removeClass("verified-rating");
            $("[data-action=startup-update][data-key=user-rating-stars]").removeClass("unverified-rating");

            if (window.brokerRatings.VerifiedReviewCount > 30) {
                $("[data-action=startup-update][data-key=user-rating-stars]").addClass("verified-rating");
            } else {
                $("[data-action=startup-update][data-key=user-rating-stars]").addClass("unverified-rating");
            }

            $("[data-action=startup-update][data-key=user-rating-review-count]").html(window.brokerRatings.UserReviewCount);

            var reviewMark = '(<span>' + window.brokerRatings.UserReviewCount + '</span>';
            if (window.brokerRatings.VerifiedReviewCount > 30) {
                reviewMark += '&nbsp;<img src="/Content/dist/images/icons/small-check-mark-icon.svg" />';
            }
            reviewMark += ')';

            $("[data-action=startup-update][data-key=user-rating-review-count-with-mark]").html(reviewMark);

            $("[data-action=startup-update][data-key=user-rating-review-count-full-link]").html(GetUserReviewCountWithFullLink(window.brokerRatings.VerifiedReviewCount, window.brokerRatings.UserReviewCount));
            $("[data-action=startup-update][data-key=user-rating-review-count-with-popover]").html(GetUserReviewCountWithPopover(window.brokerRatings.VerifiedReviewCount, window.brokerRatings.UserReviewCount));
            $("[data-action=startup-update][data-key=user-rating-review-count-popover-text]").html(GetUserReviewCountPopoverText(window.brokerRatings.VerifiedReviewCount, window.brokerRatings.UserReviewCount));

            if (window.brokerRatings.UserRatingRank > 0) {
                var userRankDesc = window.brokerResxStrings['Ranked0OutOf12'].replaceAll("{0}", window.brokerRatings.UserRatingRank)
                    .replaceAll("{1}", window.brokerRatings.PrimaryCategoryBrokers)
                    .replaceAll("{2}", primaryCategory);
                $("[data-action=startup-update][data-key=user-rating-rank-description]").html(userRankDesc);
            } else {
                $("[data-action=startup-update][data-key=user-rating-rank-description]").html("Not Ranked (" + primaryCategory + ")");
            }

            $("[data-action=startup-update] [data-toggle=tooltip]").tooltip('dispose').tooltip({ boundary: 'window' });

            if ($("#tab-news").length > 0) {
                $("#tab-news a").html(window.NEWS + ' (' + (window.brokerRatings.NewsCount || 0) + ')'); 
            }

            if ($("#tab-inline-forum").length > 0 && $("#tab-inline-forum #discussion-counter").length > 0) {
                var outString = $("#tab-inline-forum #discussion-counter").data('orgtext');
                if (!outString) outString = 'Forum Posts ({0})';
                $("#tab-inline-forum #discussion-counter").html(outString.replace("{0}", (window.brokerRatings.ForumPostCount || 0)));
            }

        }
    });
}

function RatingValue(number) {
    if (!number) number = 0;
    var localeCode = window.CURRENT_CULTURE;
    return number.toLocaleString(localeCode, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

function GetRatingStarsHtml(number) {
    if (!number) number = 0;

    var stars = Math.round(number);
    var half = 0;
    if (Math.floor(number) == stars && number > stars) half = 1;

    var content = '<div class="star-holder">';
    if (stars > 0) {
        content += '<span class="typcn stars-' + stars + '"></span>';
    }
    if (half) {
        content += '<span class="typcn typcn-star-half-outline"></span>';
    }
    var remain = 5 - stars - half;
    content += '<span class="typcn outline-stars-' + remain + '"></span>';
    content += '</div>';
    return content;
}

function GetRatingsTableHtml(ratings) {
    var ratingList = [];
    var fxvLink = window.brokerInfo['fxvLink'];

    if (ratings.IsCryptoExchange) {
        ratingList.push({ title: window.brokerResxStrings['Regulation'], popover: window.brokerResxStrings['RegulationRatingPopover'], rating: ratings.RegulationRating || 0, weight: 1 });
    } else {
        ratingList.push({ title: window.brokerResxStrings['Regulation'], popover: window.brokerResxStrings['RegulationRatingPopover'], rating: ratings.RegulationRating || 0, weight: 2 });
    }

    if (!ratings.IsCryptoExchange) {
        ratingList.push({ title: window.brokerResxStrings['UserRating'], popover: window.brokerResxStrings['UserRatingPopoverText'], rating: ratings.UserRating, weight: 3, isUserRating: 1 });
    }

    ratingList.push({ title: window.brokerResxStrings['Popularity'], popover: window.brokerResxStrings['PopularityRatingPopover'], rating: ratings.PopularityRating, weight: 3 });

    if (ratings.IsCryptoExchange) {
        ratingList.push({ title: window.brokerResxStrings['Liquidity'], popover: window.brokerResxStrings['LiquidityRatingPopover'], rating: ratings.LiquidityRating || 1, weight: 1 });
    }

    ratingList.push({ title: window.brokerResxStrings['PricingRating'], popover: null, rating: ratings.PricingRating, weight: 1 });
    ratingList.push({ title: window.brokerResxStrings['Features'], popover: null, rating: ratings.FeaturesRating, weight: 1 });
    ratingList.push({ title: window.brokerResxStrings['CustomerSupport'], popover: null, rating: ratings.CustomerSupportRating, weight: 1 });

    ratingList.sort(function (a, b) {
        if (a.rating && !b.rating) return -1;
        if (!a.rating && b.rating) return 1;
        return b.weight - a.weight;
    });

    var content = '';

    ratingList.forEach(function (rating) {
        if (rating.rating)
            content += '<tr>';
        else content += '<tr class="not-rated">';

        content += '<td>';
        if (rating.popover) {
            content += '<span class="dotted-border-bottom" data-toggle="tooltip" data-html="true" title="' + rating.popover + '">' + rating.title + '</span>';
        } else {
            content += '<span>' + rating.title + '</span>';
        }
        content += '</td>';

        content += '<td>';
        if (rating.rating) {
            content += '<div class="flex align-center" style="gap: 16px; font-size: 16px; font-weight: 500; ">';
            content += '<div class="broker-detail-page-rating-stars">';
            content += GetRatingStarsHtml(rating.rating);
            content += '</div>';
            if (rating.isUserRating === 1) {
                content += "<div><span style='font-weight: 600;'>" + RatingValue(rating.rating) + "</span> <a href='" + fxvLink + "' target='_blank'>(" + ratings.UserReviewCount + " " + window.brokerResxStrings['Reviews'] + ") <img class='link-image' src='/Content/dist/images/icons/ArrowSquareUpRight.svg' /></a></div>";
            } else {
                content += "<span>" + RatingValue(rating.rating) + "</span>";
            }

            content += '</div>';
        } else {
            content += '<div class="flex align-center">' + window.brokerResxStrings['NotRated'] + '</div>';
        }
        content += '</td>';

        content += '<td>' + rating.weight + '</td >';

        content += '</tr>';
    });

    return content;
}

function GetUserReviewCountWithFullLink(verifiedReviewCount, totalReviewCount) {
    var content = '';

    var popoverTemplate = "<div class='tooltip user-rating-tooltip' role='tooltip'><div class='arrow'></div><div class='tooltip-inner'></div></div>";
    if (window.PORTAL_CODE === 'FXV') {
        if (verifiedReviewCount >= 30) {
            var popoverText = window.brokerResxStrings['UserReviewCountPopoverVerifiedText'];
            popoverText = popoverText.replaceAll('{0}', verifiedReviewCount);
            content = '<a href="javascript:void(0);" class="font-14" style="white-space: nowrap; text-decoration: none;" data-action="broker-tab-navigate" data-target="user-reviews" data-scroll="user-reviews" data-toggle="tooltip" data-template="' + popoverTemplate + '" data-html="true" title="' + popoverText + '">(<span class="text-dotted-underline">' + totalReviewCount + ' ' + window.brokerResxStrings["Reviews"] + '</span>&nbsp;<img src="/Content/dist/images/icons/small-check-mark-icon.svg" />)</a>';
        } else if (totalReviewCount > 0) {
            var popoverText = window.brokerResxStrings['ReviewCountPopoverUnverified'];
            popoverText = popoverText.replaceAll('{0}', verifiedReviewCount).replaceAll('{1}', totalReviewCount - verifiedReviewCount);
            content = '<a href="javascript:void(0);" class="font-14" style="white-space: nowrap; text-decoration: none;" data-action="broker-tab-navigate" data-target="user-reviews" data-scroll="user-reviews" data-toggle="tooltip" data-template="' + popoverTemplate + '" data-html="true" title="' + popoverText + '">(<span class="text-dotted-underline">' + totalReviewCount + ' ' + window.brokerResxStrings["Reviews"] + '</span>)</a>';
        } else {
            content = '<a href="javascript:void(0);" class="font-14" style="white-space: nowrap; text-decoration: none;" data-action="broker-tab-navigate" data-target="user-reviews" data-scroll="user-reviews">(0 ' + window.brokerResxStrings["Reviews"] + ')</a>';
        }
    } else {
        var fxvLink = window.brokerInfo['fxvLink'];
        if (verifiedReviewCount > 30) {
            var popoverText = window.brokerResxStrings['UserReviewCountPopoverVerifiedText'];
            popoverText = popoverText.replaceAll('{0}', verifiedReviewCount);
            content = '<a href="' + fxvLink + '#user-reviews" target="_blank" class="font-14" style="white-space: nowrap; text-decoration: none;" data-toggle="tooltip" data-template="' + popoverTemplate + '" data-html="true" title="' + popoverText + '">(<span class="text-dotted-underline">' + totalReviewCount + ' ' + window.brokerResxStrings["Reviews"] + '</span>&nbsp;<img src="/Content/dist/images/icons/small-check-mark-icon.svg" />) <img class="link-image" src="/Content/dist/images/icons/ArrowSquareUpRight.svg" /></a>';
        } else if (totalReviewCount > 0) {
            var popoverText = window.brokerResxStrings['ReviewCountPopoverUnverified'];
            popoverText = popoverText.replaceAll('{0}', verifiedReviewCount).replaceAll('{1}', totalReviewCount - verifiedReviewCount);
            content = '<a href="' + fxvLink + '#user-reviews" target="_blank" class="font-14" style="white-space: nowrap; text-decoration: none;" data-toggle="tooltip" data-template="' + popoverTemplate + '" data-html="true" title="' + popoverText + '">(<span class="text-dotted-underline">' + totalReviewCount + ' ' + window.brokerResxStrings["Reviews"] + ')</span>&nbsp;<img class="link-image" src="/Content/dist/images/icons/ArrowSquareUpRight.svg" /></a>';
        } else {
            content = '<a href="' + fxvLink + '#user-reviews" target="_blank" class="font-14" style="white-space: nowrap; text-decoration: none;">(0 ' + window.brokerResxStrings["Reviews"] + ') <img class="link-image" src="/Content/dist/images/icons/ArrowSquareUpRight.svg" /></a>';
        }
    }

    return content;
}

function GetUserReviewCountWithPopover(verifiedReviewCount, totalReviewCount) {
    var content = '';
    if (verifiedReviewCount >= 30) {
        var popoverText = window.brokerResxStrings['UserReviewCountPopoverVerifiedText'];
        popoverText = popoverText.replaceAll("{0}", verifiedReviewCount);
        content = "<a href=\"javascript:void(0);\" class=\"review-count\" data-toggle=\"tooltip\" data-template='<div class=\"tooltip user-rating-tooltip\" role=\"tooltip\"><div class=\"arrow\"></div><div class=\"tooltip-inner\"></div></div>' data-html=\"true\" title=\"" + popoverText + "\">(<span class=\"text-dotted-underline\">" + totalReviewCount + "</span>&nbsp;<img src=\"/Content/dist/images/icons/small-check-mark-icon.svg\" />)</a>";
    } else if (totalReviewCount > 0) {
        var popoverText = window.brokerResxStrings['ReviewCountPopoverUnverified'];
        popoverText = popoverText.replaceAll("{0}", verifiedReviewCount).replaceAll("{1}", totalReviewCount - verifiedReviewCount);
        content = "<a href=\"javascript:void(0);\" class=\"review-count\" data-toggle=\"tooltip\" data-template='<div class=\"tooltip user-rating-tooltip\" role=\"tooltip\"><div class=\"arrow\"></div><div class=\"tooltip-inner\"></div></div>' data-html=\"true\" title=\"" + popoverText + "\">(<span class=\"text-dotted-underline\">" + totalReviewCount + "</span>)</a>";
    } else {
        content = "<a href=\"javascript:void(0);\" class=\"review-count\">(0)</a>";
    }
    return content;
}

function GetUserReviewCountPopoverText(verifiedReviewCount, totalReviewCount) {
    if (verifiedReviewCount >= 30) {
        var popoverText = window.brokerResxStrings['UserReviewCountPopoverVerifiedText'];
        popoverText = popoverText.replaceAll("{0}", verifiedReviewCount).replaceAll("<p>", "").replaceAll("</p>", "");
        return popoverText;
    } else if (totalReviewCount > 0) {
        var popoverText = window.brokerResxStrings['ReviewCountPopoverUnverified'];
        popoverText = popoverText.replaceAll("{0}", verifiedReviewCount).replaceAll("{1}", totalReviewCount - verifiedReviewCount).replaceAll("<p>", "").replaceAll("</p>", "");
        return popoverText;
    }

    return '';
}

function parseFloatOpts(str) {

    if (typeof str === "number") {
        return str;
    }
    if (str != undefined && str != null && str != "") {
        str = str.toString();
    } else {
        return str;
    }
    var ar = str.split(/\.|,/);

    var value = '';
    for (var i in ar) {
        if (i > 0 && i == ar.length - 1) {
            value += ".";
        }
        value += ar[i];
    }
    return Number(value);
}

function GenerateReviewWidgetsConfigModel() {
    var ReviewWidgetsConfig = new Object();
    ReviewWidgetsConfig.OverallRating = parseFloatOpts($("input[name='overall-rating']").val());
    ReviewWidgetsConfig.UserRating = parseFloatOpts($("input[name='user-rating']").val());
    ReviewWidgetsConfig.OverallRank = Number($("input[name='overall-rank']").val());
    ReviewWidgetsConfig.UserRank = Number($("input[name='user-rank']").val());
    ReviewWidgetsConfig.RegulationRating = parseFloatOpts($("input[name='regulation-rating']").val());
    ReviewWidgetsConfig.UserReivewsNum = Number($("input[name='user-review-count']").val());
    ReviewWidgetsConfig.BrokerId = Number($("input[name='broker-id']").val());
    ReviewWidgetsConfig.UrlSlug = $("input[name='url-slug']").val();
    ReviewWidgetsConfig.EntityType = $("input[name='entity-type']").val();
    ReviewWidgetsConfig.BrokerName = $("input[name='broker-name']").val();
    return ReviewWidgetsConfig;
}

function FetchReviewWidgetsLocalizedContent(lang) {
    if (lang === "browser") {
        lang = window.navigator.userLanguage || window.navigator.language;
        lang = lang.substring(0, 2);
    }
    else if (lang === "page") {
        lang = window.CURRENT_LANG;
    }


    var url = '/widgets/fxv-user-review-widgets-content';
    if (lang !== '') {
        url = '/' + lang + url;
    }

    var ReviewWidgetsConfigModel = GenerateReviewWidgetsConfigModel();

    $.ajax({
        type: "POST",
        url: url,
        data: {
            bodyFileName: "_FXVReivewsWidgetBody.cshtml",
            lang: lang,
            model: JSON.stringify(ReviewWidgetsConfigModel)
        },
        success: function (data) {
            $(".user-reviews-widgets-content").html(data.content);
            var ratingTypeSelect = document.getElementById("reviews-widget-rating-type-select");
            var pageLinkSelect = document.getElementById("reviews-widget-page-link-select");
            var elementSelect = document.getElementById("reviews-widget-element-one-select");
            var themeSelect = document.getElementById("reviews-widget-theme-select");
            var sizeInput = document.getElementById("size");
            var maxWidthInput = document.getElementById("maximum-width");
            OnChangedReviewsWidgetRatingType(ratingTypeSelect);
            OnChangedReviewsWidgetPageLink(pageLinkSelect);
            OnChangedReviewsWidgetElement(elementSelect);
            OnChangedReviewsWidgetTheme(themeSelect);
            UpdateReviewWidgetsStyle(sizeInput);
            UpdateReviewsWidgetMaximumWidth(maxWidthInput);
            $('input[type=radio][name=widgets-form]').change(function () {
                GenerateReivewsWidgetRemoteScript();
            });
            GenerateReivewsWidgetRemoteScript();
        },
        error: function () {

        }
    })
}

function OnChangedReviewsWidgetLanguage(e) {
    FetchReviewWidgetsLocalizedContent(e.value);
}

function OnChangedReviewsWidgetRatingType(e) {
    var ratingType = e.value;
    $('.reviews-widget-element-select option').removeClass('d-none');
    $('[class*="option-for"]').removeClass('d-none');
    $('[class*="option-for"]').addClass('d-none');
    $('.option-for-' + ratingType).removeClass('d-none');
    var userRating = $("input[name='user-rating']").val();
    var expertRating = $("input[name='overall-rating']").val();
    var regulationRating = $("input[name='regulation-rating']").val();
    var userRank = $("input[name='user-rank']").val();
    var overallRank = $("input[name='overall-rank']").val();
    switch (ratingType) {
        case "user-rating":
            $(".rating-num").html(Number(userRating).toFixed(1))
            $(".rank-num").html(Number(userRank))
            $('option[class*="rank-"]').each(function (index, elem) {
                $(elem).removeClass('d-none');
                var html = $(elem).html();
                html = html.replace(/#\d+/, '#' + userRank);
                $(elem).html(html);
            });
            if (userRank <= 30) {
                $('option[class*="top-global-"]').removeClass('d-none');
            }
            else {
                $('option[class*="top-global-"]').each(function (index, elem) {
                    if (!$(elem).hasClass('d-none')) {
                        $(elem).addClass('d-none');
                    }
                })
            }
            $('#reviews-widget-element-two-select').attr("disabled", false);
            $('#reviews-widget-element-three-select').attr("disabled", false);
            $('#reviews-widget-element-one-select option').attr("selected", false);
            $('#reviews-widget-element-two-select option').attr("selected", false);
            $('#reviews-widget-element-three-select option').attr("selected", false);
            $('#reviews-widget-element-one-select option.your-star-rating').attr("selected", true);
            $('#reviews-widget-element-two-select option.transparency-partner-text').attr("selected", true);
            $('#reviews-widget-element-three-select option.none').attr("selected", true);
            break;
        case "expert-rating":
            $(".rating-num").html(Number(expertRating).toFixed(1))
            $(".rank-num").html(Number(overallRank))
            $('option[class*="rank-"]').each(function (index, elem) {
                $(elem).removeClass('d-none');
                var html = $(elem).html();
                html = html.replace(/#\d+/, '#' + overallRank);
                $(elem).html(html);
            });
            if (overallRank <= 30) {
                $('option[class*="top-global-"]').removeClass('d-none');
            }
            else {
                $('option[class*="top-global-"]').each(function (index, elem) {
                    if (!$(elem).hasClass('d-none')) {
                        $(elem).addClass('d-none');
                    }
                })
            }
            $('#reviews-widget-element-two-select').attr("disabled", false);
            $('#reviews-widget-element-three-select').attr("disabled", false);
            $('#reviews-widget-element-one-select option').attr("selected", false);
            $('#reviews-widget-element-two-select option').attr("selected", false);
            $('#reviews-widget-element-three-select option').attr("selected", false);
            $('#reviews-widget-element-one-select option.your-star-rating').attr("selected", true);
            $('#reviews-widget-element-two-select option.transparency-partner-text').attr("selected", true);
            $('#reviews-widget-element-three-select option.none').attr("selected", true);
            break;
        case "regulation-rating":
            $(".rating-num").html(Number(regulationRating).toFixed(1))
            $('.reviews-widget-element-select option').each(function (index, elem) {
                if (!$(elem).hasClass('d-none')) {
                    $(elem).addClass('d-none');
                }
            })
            $('.option-for-' + ratingType).removeClass('d-none');
            $('.reviews-widget-element-select option.none').removeClass('d-none');
            $('#reviews-widget-element-one-select option').attr("selected", false);
            $('#reviews-widget-element-two-select option').attr("selected", false);
            $('#reviews-widget-element-three-select option').attr("selected", false);
            $('#reviews-widget-element-one-select option.option-for-regulation-rating').attr("selected", true);
            $('#reviews-widget-element-two-select option.none').attr("selected", true);
            $('#reviews-widget-element-three-select option.none').attr("selected", true);
            $('#reviews-widget-element-two-select').attr("disabled", true);
            $('#reviews-widget-element-three-select').attr("disabled", true);
            break;
    }
    var elementSelect = document.getElementById("reviews-widget-element-one-select");
    OnChangedReviewsWidgetElement(elementSelect);
    GenerateReivewsWidgetRemoteScript();
}

function OnChangedReviewsWidgetPageLink(e) {
    var pageLink = e.value;
    var brokerId = Number($("input[name='broker-id']").val());
    var urlSlug = $("input[name='url-slug']").val();
    switch (pageLink) {
        case "review":
            $('.user-reviews-widgets-content a').attr("href", GetBrokerTabUrl(window.location.pathname, "review", brokerId, urlSlug));
            break;
        case "user-reviews":
            $('.user-reviews-widgets-content a').attr("href", GetBrokerTabUrl(window.location.pathname, "user-reviews", brokerId, urlSlug));
            break;
        case "review-page-regulation":
            var id = 'regulation';
            $("#tab-review-box h2").each(function (index, elem) {
                if ($(elem).html().includes("Regulation")) {
                    id = $(elem).attr('id');
                    return;
                }
            })
            $('.user-reviews-widgets-content a').attr("href", GetBrokerTabUrl(window.location.pathname, "review", brokerId, urlSlug) + "#" + id);
            break;
    }
    GenerateReivewsWidgetRemoteScript();
}

function OnChangedReviewsWidgetElement(e) {
    var element = e.value;
    var ratingType = $("select[id='reviews-widget-rating-type-select']").val();
    $('.reviews-widget-element-select option').removeClass('d-none');
    $('[class*="option-for"]').addClass('d-none');
    $('.option-for-' + ratingType).removeClass('d-none');
    var userRank = $("input[name='user-rank']").val();
    var overallRank = $("input[name='overall-rank']").val();
    switch (ratingType) {
        case "user-rating":
            if (userRank <= 30) {
                $('option[class*="top-global-"]').removeClass('d-none');
            }
            else {
                $('option[class*="top-global-"]').each(function (index, elem) {
                    if (!$(elem).hasClass('d-none')) {
                        $(elem).addClass('d-none');
                    }
                })
            }
            break;
        case "expert-rating":
            if (overallRank <= 30) {
                $('option[class*="top-global-"]').removeClass('d-none');
            }
            else {
                $('option[class*="top-global-"]').each(function (index, elem) {
                    if (!$(elem).hasClass('d-none')) {
                        $(elem).addClass('d-none');
                    }
                })
            }
            break;
        case "regulation-rating":
            $('.reviews-widget-element-select option').each(function (index, elem) {
                if (!$(elem).hasClass('d-none')) {
                    $(elem).addClass('d-none');
                }
            })
            $('.option-for-' + ratingType).removeClass('d-none');
            $('.reviews-widget-element-select option.none').removeClass('d-none');
            $('option[class*="top-global-"]').each(function (index, elem) {
                if (!$(elem).hasClass('d-none')) {
                    $(elem).addClass('d-none');
                }
            })
            break;
    }
    $('.user-reviews-widgets-content span').removeClass('d-none');
    $('.user-reviews-widgets-content span').addClass('d-none');
    $('.user-reviews-widgets-content .broker-detail-page-rating-stars').removeClass('d-none');
    $('.user-reviews-widgets-content .broker-detail-page-rating-stars').addClass('d-none');
    $('.reviews-widget-element-select').each(function (index, elem) {
        var selectedOption = elem.value;
        if(selectedOption != 'none')
            $('option.' + selectedOption).addClass('d-none');
        $(elem).find('option.' + selectedOption).removeClass('d-none');
        if (selectedOption != 'none') {
            if (selectedOption == "your-star-rating") {
                $('.user-reviews-widgets-content .' + ratingType + '-stars').removeClass('d-none');
                $('.user-reviews-widgets-content .' + ratingType + '-stars span').removeClass('d-none');
            }
            else {
                $('.user-reviews-widgets-content span.' + selectedOption).removeClass('d-none');
                if (selectedOption == "regulation-rating-text") {
                    $('.user-reviews-widgets-content .' + ratingType + '-stars').removeClass('d-none');
                    $('.user-reviews-widgets-content .' + ratingType + '-stars span').removeClass('d-none');
                }
            }
        }
    })
    GenerateReivewsWidgetRemoteScript();
}

function OnIncludeLinkCheckboxChange(e) {
    var isChecked = e.checked;
    console.log(isChecked)
    var pageLink = $("#reviews-widget-page-link-select").val();
    var brokerId = Number($("input[name='broker-id']").val());
    var urlSlug = $("input[name='url-slug']").val();
    var linkUrl = "/brokers/" + brokerId + "/" + urlSlug + "?tab=";
    var tab = pageLink;

    if (pageLink == "review-page-regulation") {
        tab = "review";
    }

    var linkUrl = "/brokers/" + urlSlug + "-" + tab + "-" + brokerId;

    if (pageLink == "review-page-regulation") {
        var id = 'regulation';
        $("#tab-review-box h2").each(function (index, elem) {
            if ($(elem).html().includes("Regulation")) {
                id = $(elem).attr('id');
                return;
            }
        })
        linkUrl += "#" + id;
    }

    if (isChecked) {
        $(".widgets-form").wrap("<a href=" + linkUrl + "></a>");
        $(".user-reviews-widgets-content a.text-link").removeClass("d-none");
    }
    else {
        $(".widgets-form").unwrap();
        $(".user-reviews-widgets-content a.text-link").addClass("d-none");
    }
    GenerateReivewsWidgetRemoteScript();
}
function OnChangedReviewsWidgetTheme(e) {
    var theme = e.value;
    $(".widgets-form").each(function (index, elem) {
        if ($(elem).is("[class*='theme-']")) {
            $(elem).removeClass(function (index, className) {  
                return (className.match(/(^|\s)theme-\S+/g) || []).join(' ');  
            });  
        }
        $(elem).addClass("theme-" + theme);
    })
    var baseUrl = window.location.origin;
    $(".user-reviews-widgets-content").removeClass("dark-background");
    $(".text-link").removeClass("transparent-dark-link");
    if (theme.toLowerCase() == 'light' || theme.toLowerCase() == 'transparent-light') {
        $(".rating-note").addClass("light");
        $(".widgets-form span").addClass("light");
        $(".widgets-form img").attr('src', baseUrl + '/Content/dist/images/PageElements/FXV/FXVERIFY_widgets_black_logo.svg')
    }
    else {
        if (theme.toLowerCase() == 'transparent-dark') {
            $(".user-reviews-widgets-content").addClass("dark-background");
            $(".text-link").addClass("transparent-dark-link");
        }
        $(".rating-note").removeClass("light");
        $(".widgets-form span").removeClass("light");
        $(".widgets-form img").attr('src', baseUrl + '/Content/dist/images/PageElements/FXV/FXVERIFY_widgets_white_logo.svg')
    }
    GenerateReivewsWidgetRemoteScript();
}

function UpdateReviewWidgetsStyle(e) {
    var width = e.value;
    $(".user-reviews-widgets-content .broker-detail-page-rating-stars").css("font-size", 18 * width / 100);
    $(".user-reviews-widgets-content .rank-span").css("font-size", 13 * width / 100);
    $(".user-reviews-widgets-content .rating-span").css("font-size", 13 * width / 100);
    $(".user-reviews-widgets-content .rating-note").css("font-size", 11 * width / 100);
    $(".user-reviews-widgets-content img").css("width", 100 * width / 100);
    $(".user-reviews-widgets-content img").css("height", 30 * width / 100);
    $(".user-reviews-widgets-content .rating-num").css("font-size", 20 * width / 100);
    GenerateReivewsWidgetRemoteScript();
}

function UpdateReviewsWidgetMaximumWidth(e) {
    var maxWidth = e.value;
    if (maxWidth > 0) {
        $(".widgets-form.vertical-widgets-form").css("max-width", maxWidth + "px");
        $(".review-widget-container").css("max-width", maxWidth + "px");
    }
    else {
        $(".widgets-form.vertical-widgets-form").css("max-width", "100%");
        $(".review-widget-container").css("max-width", "100%");
    }
    GenerateReivewsWidgetRemoteScript();
}

function OnCopyReviewWidgetEmbedScript() {
    var calendarPreviewEl = document.getElementById('embed-script-preview-output');
    if (calendarPreviewEl) {
        var scriptVal = calendarPreviewEl.value;
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = scriptVal;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);

        var notificationEl = document.getElementById('review-widget-embed-copy-notification-panel');
        if (notificationEl) {
            notificationEl.style.display = 'block';
            setTimeout(function () {
                notificationEl.style.display = 'none';
            }, 3000);
        }
    }

    GenerateReivewsWidgetRemoteScript();
}

function GenerateReivewsWidgetRemoteScript() {
    var ReviewsWidgetConfig = new Object();
    var language = "browser";
    if (document.getElementById('reviews-widget-language-select') != null) {
        language = document.getElementById('reviews-widget-language-select').value;
    }

    if (language != "browser") ReviewsWidgetConfig.Lang = language;

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    var hostUrlSrc = hostUrl;
    if (!hostUrlSrc) {
        hostUrlSrc = "https://widgets.clearapi.io";
    }

    ReviewsWidgetConfig.Url = hostUrl;
    ReviewsWidgetConfig.UrlSrc = hostUrlSrc;
    ReviewsWidgetConfig.Calculator = "reviews";

    var defaultThemeMode = $("#reviews-widget-theme-select").val();
    ReviewsWidgetConfig.DefaultThemeMode = defaultThemeMode;

    var width = $("#size").val();
    ReviewsWidgetConfig.Width = width;
    

    if ($("input[name='widgets-form']:checked").length) {
        var widgetType = $("input[name='widgets-form']:checked").val();
        var containerWidth = $("#maximum-width").val();
        if (containerWidth > 0 && widgetType == "vertical")
            ReviewsWidgetConfig.ContainerWidth = containerWidth;
        ReviewsWidgetConfig.WidgetProperties = {
            WidgetType: widgetType,
            RatingType: $("#reviews-widget-rating-type-select").val(),
            LinkUrl: $("#reviews-widget-page-link-select").val(),
            Elements: [$("#reviews-widget-element-one-select").val(), $("#reviews-widget-element-two-select").val(), $("#reviews-widget-element-three-select").val()],
            IncludeLink: $("#include_link").is(":checked"),
            BrokerId: Number($("input[name='broker-id']").val()),
        };
    } else {
        ReviewsWidgetConfig.WidgetProperties = undefined;
    }
    if ($('#embed-script-preview-output').length) {
        document.getElementById('embed-script-preview-output').value = GenerateReviewsWidgetScript(ReviewsWidgetConfig);
    }
}

function GenerateReviewsWidgetScript(WidgetConfig) {
    var containerId = WidgetConfig.Calculator + "-" + Math.ceil(Math.random() * 1000000);

    var linkUrl = WidgetConfig.Url + window.location.pathname + "?tab=";

    var linkTab = $("#reviews-widget-page-link-select").val();

    var targetTab = linkTab;

    if (linkTab == "review-page-regulation")
        targetTab = "review";

    var linkUrl = WidgetConfig.Url + GetBrokerSwitchedTabUrl(window.location.pathname, targetTab);

    if (linkTab == "review-page-regulation") {
        var id = 'regulation';
        $("#tab-review-box h2").each(function (index, elem) {
            if ($(elem).html().includes("Regulation")) {
                id = $(elem).attr('id');
                return;
            }
        })
        linkUrl += ("#" + id);
    }

    if (WidgetConfig.WidgetProperties !== undefined) {
        var previewScript = "<div style='display: inline-block !important;";
        if (WidgetConfig.ContainerWidth > 0 && WidgetConfig.WidgetProperties.WidgetType == "vertical") {
            previewScript += "max-width: " + WidgetConfig.ContainerWidth + "px;";
        }
        previewScript += "'>";
        previewScript += "<div id=\"" + containerId + "\">";

        previewScript += "<script type=\"text/javascript\" src=\"" + WidgetConfig.UrlSrc + RemoteScriptJsLink + "\"><\/script>";

        previewScript += "<script type=\"text/javascript\"> RemoteCalc({";
        if (WidgetConfig.Lang) {
            previewScript += "\"Lang\":\"" + WidgetConfig.Lang + "\",";
        }
        previewScript += "\"Url\":\"" + WidgetConfig.UrlSrc + "\", ";
        previewScript += "\"Calculator\":\"" + WidgetConfig.Calculator + "\",";
        if (WidgetConfig.DefaultThemeMode) {
            previewScript += "\"DefaultThemeMode\": \"" + WidgetConfig.DefaultThemeMode + "\",";
        }
        if (WidgetConfig.Width) {
            previewScript += "\"Width\": \"" + WidgetConfig.Width + "\",";
        }
        if (WidgetConfig.ContainerWidth) {
            previewScript += "\"ContainerWidth\": \"" + WidgetConfig.ContainerWidth + "\",";
        }
        previewScript += "\"WidgetProperties\":" + JSON.stringify(WidgetConfig.WidgetProperties) + ",";
        previewScript += "\"ContainerId\":\"" + containerId + "\"";
        previewScript += "});<\/script><\/div>";

        if (WidgetConfig.WidgetProperties.IncludeLink == true) {
            previewScript += "<a href = \"" + linkUrl + "\" target=\"_blank\" id=\"" + containerId + "-review-link\" data-broker-name=\"" + window.brokerInfo['name'] + "\" style=\"font-size: 13px !important; font-family:'Open Sans', Arial !important; margin-top: 8px !important; ";
            if (WidgetConfig.DefaultThemeMode == 'transparent-dark') {
                previewScript += "color: #FFFFFF !important; text-decoration: underline !important;";
            }
            else {
                previewScript += "color: #0275D8 !important; text-decoration: none !important;"
            }
            previewScript += "display: none; line-height:130% !important;\" >" + window.brokerResxStrings["ReviewsVerifiedByFxVerify"].replace("{0}", window.brokerInfo['name']) + "</a>";
        }

        previewScript += "</div>";

        return previewScript;
    }

    return "";
}

function InvestorDataDiv(val) {
    $('#VerificationOption-error').parent().removeClass('has-danger');
    $('#investor-data').hide();
    if (val === 1) {
        $('#investor-data').show();
    }
}

function RenderBrokerSymbolsTableContent(html) {

    $('#broker-symbols-table-content').html(html);
    $('#broker-symbols-table-content').data('status', 'loaded');

    InitializeScrollTable('#broker-symbols-table-content #broker-symbols-table');

    window.Site.UpdateLastUpdatedDate();
    window.Site.InitAuthorPopovers();

    $('[data-toggle="popover-trading-hours"]').popover('dispose');

    $('[data-toggle="popover-trading-hours"]')
        .popover({
            html: true,
            trigger: "manual",
            placement: "auto",
            template: '<div class="popover trading-hours-popover" role="tooltip"><div class="popover-body"></div></div>',
            content: function () {
                var hoursObj = $(this).data('hours');

                var out = '<table class="broker-table">';
                out += '<tr class="broker-table-header"><td>' + window.brokerResxStrings['Sessions'] + '</td><td>' + window.brokerResxStrings['Quotes'] + '</td><td>' + window.brokerResxStrings['Trade'] + '</td></tr>';
                out += '<tr><td>' + window.brokerResxStrings['Sunday'] + '</td><td>' + (hoursObj[0] ? hoursObj[0].Item1 : '') + '</td><td>' + (hoursObj[0] ? hoursObj[0].Item2 : '') + '</td></tr>';
                out += '<tr><td>' + window.brokerResxStrings['Monday'] + '</td><td>' + (hoursObj[1] ? hoursObj[1].Item1 : '') + '</td><td>' + (hoursObj[1] ? hoursObj[1].Item2 : '') + '</td></tr>';
                out += '<tr><td>' + window.brokerResxStrings['Tuesday'] + '</td><td>' + (hoursObj[2] ? hoursObj[2].Item1 : '') + '</td><td>' + (hoursObj[2] ? hoursObj[2].Item2 : '') + '</td></tr>';
                out += '<tr><td>' + window.brokerResxStrings['Wednesday'] + '</td><td>' + (hoursObj[3] ? hoursObj[3].Item1 : '') + '</td><td>' + (hoursObj[3] ? hoursObj[3].Item2 : '') + '</td></tr>';
                out += '<tr><td>' + window.brokerResxStrings['Thursday'] + '</td><td>' + (hoursObj[4] ? hoursObj[4].Item1 : '') + '</td><td>' + (hoursObj[4] ? hoursObj[4].Item2 : '') + '</td></tr>';
                out += '<tr><td>' + window.brokerResxStrings['Friday'] + '</td><td>' + (hoursObj[5] ? hoursObj[5].Item1 : '') + '</td><td>' + (hoursObj[5] ? hoursObj[5].Item2 : '') + '</td></tr>';
                out += '<tr><td>' + window.brokerResxStrings['Saturday'] + '</td><td>' + (hoursObj[6] ? hoursObj[6].Item1 : '') + '</td><td>' + (hoursObj[6] ? hoursObj[6].Item2 : '') + '</td></tr>';

                out += '</table>';

                return out;

            }
        }).on("mouseenter", function () {
            var _this = this;
            $(this).popover("show");
            $(".popover").on("mouseleave", function () {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function () {
            var _this = this;
            setTimeout(function () {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide");
                }
            }, 100);
        });

    $('[data-toggle="popover-swap-rates"]').popover('dispose');

    $('[data-toggle="popover-swap-rates"]')
        .popover({
            html: true,
            trigger: "manual",
            placement: "auto",
            template: '<div class="popover trading-hours-popover" role="tooltip"><div class="popover-body"></div></div>',
            content: function () {
                var ratesObj = $(this).data('rates');

                var out = '<table class="broker-table">';
                if (ratesObj[0] != 0)
                    out += '<tr><td>' + window.brokerResxStrings['Sunday'] + '</td><td>' + ratesObj[0] + '</td></tr>';
                if (ratesObj[1] != 0)
                    out += '<tr><td>' + window.brokerResxStrings['Monday'] + '</td><td>' + ratesObj[1] + '</td></tr>';
                if (ratesObj[2] != 0)
                    out += '<tr><td>' + window.brokerResxStrings['Tuesday'] + '</td><td>' + ratesObj[2] + '</td></tr>';
                if (ratesObj[3] != 0)
                    out += '<tr><td>' + window.brokerResxStrings['Wednesday'] + '</td><td>' + ratesObj[3] + '</td></tr>';
                if (ratesObj[4] != 0)
                    out += '<tr><td>' + window.brokerResxStrings['Thursday'] + '</td><td>' + ratesObj[4] + '</td></tr>';
                if (ratesObj[5] != 0)
                    out += '<tr><td>' + window.brokerResxStrings['Friday'] + '</td><td>' + ratesObj[5] + '</td></tr>';
                if (ratesObj[6] != 0)
                    out += '<tr><td>' + window.brokerResxStrings['Saturday'] + '</td><td>' + ratesObj[6] + '</td></tr>';

                out += '</table>';
                return out;

            }
        }).on("mouseenter", function () {
            var _this = this;
            $(this).popover("show");
            $(".popover").on("mouseleave", function () {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function () {
            var _this = this;
            setTimeout(function () {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide");
                }
            }, 100);
        });
}

function InitSymbolsTabContentIfExists(brokerId) {
    if ($('#broker-symbols-table-content').length == 0)
        return;

    if ($('#broker-symbols-table-content').isInViewport() != true) {
        return;
    }

    if ($('#broker-symbols-table-content').data('status') == 'loaded' || $('#broker-symbols-table-content').data('status') == 'loading')
        return;

    if (window.brokerInfo['CachedSymbols'] != undefined) {
        RenderBrokerSymbolsTableContent(window.brokerInfo['CachedSymbols']);
        return;
    }

    $('#broker-symbols-table-content').data('status', 'loading');

    $.ajax({
        type: "GET",
        url: '/' + window.CURRENT_LANG + '/api/brokers/broker-symbols-content/' + brokerId,
        success: function (data) {
            window.brokerInfo['CachedSymbols'] = data;
            RenderBrokerSymbolsTableContent(data);
        },
        error: function () {

        }
    });
    
}

//function InitUserReviewsMini(brokerId) {

//    if ($('#mini-review-template').length == 0)
//        return;

//    window.SocialProfile.IgniteMiniReviews(brokerId);
//}

function SetupExpandableText(selector) {

    // Select all cells in the 3rd column of the table
    const detailsCells = document.querySelectorAll(selector);

    detailsCells.forEach(function (cell) {
        const fullText = cell.textContent.trim();

        // Only process cells with text longer than 100 characters
        if (fullText.length > 100) {
            const shortText = fullText.substring(0, 100);

            // Set up the truncated text with a "more" link
            cell.innerHTML =
                "<span class='short-text'>" + shortText + "...</span>" +
                "<span class='full-text' style='display: none;'>" + fullText + "</span>" +
                "<a href='#' class='toggle-text'>more</a>";

            // Add a click listener to the "more" link
            const toggleLink = cell.querySelector(".toggle-text");
            toggleLink.addEventListener("click", function (e) {
                e.preventDefault();

                const shortTextSpan = cell.querySelector(".short-text");
                const fullTextSpan = cell.querySelector(".full-text");

                // Toggle between short and full text
                if (fullTextSpan.style.display === "none") {
                    shortTextSpan.style.display = "none";
                    fullTextSpan.style.display = "inline";
                    toggleLink.textContent = "less";
                } else {
                    shortTextSpan.style.display = "inline";
                    fullTextSpan.style.display = "none";
                    toggleLink.textContent = "more";
                }
            });
        }
    });
}

function InitializeSortableTable() {
    $("table.sortable-table th.sort").off('click').on('click', function () {

        // Get the parent table
        var table = $(this).closest('table.sortable-table');

        table.find('th.sort').removeClass('asce');
        table.find('th.sort').removeClass('desc');

        var sortMul = 1;
        var sortDir = $(this).attr('sort-dir');
        if (sortDir === 'desc') {
            $(this).attr('sort-dir', 'asce');
            $(this).addClass('asce');
            sortMul = 1;
        } else {
            $(this).attr('sort-dir', 'desc');
            $(this).addClass('desc');
            sortMul = -1;
        }

        // Get the column number
        var colIndex = $(this).index();

        // Get the rows which doesn't include the header

        var rows = table.find('tbody tr').get();

        // Sort by the colIndex column in the rows array
        rows.sort(function (a, b) {
            var A_td = $(a).children('td').eq(colIndex);
            var B_td = $(b).children('td').eq(colIndex);

            var A = A_td.text().toUpperCase();
            if (A_td.data('value') != undefined) A = A_td.data('value');

            var B = B_td.text().toUpperCase();
            if (B_td.data('value') != undefined) B = B_td.data('value');

            if (A < B) {
                return -1 * sortMul;
            }
            if (A > B) {
                return 1 * sortMul;
            }
            return 0;
        });

        // Reorder the rows in the table
        $.each(rows, function (index, row) {
            table.children('tbody').append(row);
        });
    });


}

function GetTimeString(timeSpan, type) {
    var days = timeSpan.Days;
    var hours = timeSpan.Hours;
    var minutes = timeSpan.Minutes;

    if (type == "full") {
        var daysText = days == 1 ? "day" : "days";
        var hourText = hours == 1 ? "hour" : "hours";
        var minuteText = minutes == 1 ? "minute" : "minutes";

        var res = "";

        if (days != 0) res += days + " " + daysText;
        if (hours != 0) res += " " + hours + " " + hourText;
        if (minutes != 0) res += " " + minutes + " " + minuteText;

        return res;
    }
    else {
        var res = "";

        if (days != 0) res += days + "d";
        if (hours != 0) res += " " +  hours + "h";
        if (minutes != 0) res += " " + minutes + "m";

        return res;
    }

}

function CreateChart(PayoutsPerDate) {
    var payouts_box = document.getElementById('tab-content-box');
    const originalDisplay = payouts_box.style.display;
    payouts_box.style.display = 'block';

    var ctx = document.getElementById('broker-detail-payouts-chart').getContext('2d');
    var container = document.getElementById('broker-detail-payouts-chart').parentElement;

    var deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

    var canvasHeight = deviceWidth >= 768 ? container.offsetWidth / 3 : 300;

    var labels = [];
    var data = [];
    for (var i = PayoutsPerDate.length - 1; i >= 0; i--) {
        labels.push(PayoutsPerDate[i].Date);
        var val = PayoutsPerDate[i].PayoutsPerDate;
        data.push(val);
    }

    const gradient = ctx.createLinearGradient(0, 0, 0, canvasHeight);
    gradient.addColorStop(0.0627, "rgba(53, 232, 53, 1)");
    gradient.addColorStop(0.8555, "rgba(0, 79, 163, 1)");

    myChart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [{
                label: 'Payouts',
                data: data,
                backgroundColor: gradient,
                barPercentage: 0.6
            }]
        },
        options: {
            responsive: false,
            maintainAspectRatio: false,
            aspectRatio: 3,
            scales: {
                x: {
                    ticks: {
                        color: "rgba(255, 255, 255, 0.5)",
                        autoSkip: false,
                        maxRotation: 45, // Rotate labels diagonally
                        minRotation: 45
                    },
                    border: {
                        display: true
                    },
                    grid: {
                        display: false,
                        color: "rgba(255, 255, 255, 0.2)",
                    }
                },
                y: {
                    ticks: {
                        color: "rgba(255, 255, 255, 0.5)",
                        callback: function (value) { return ("$" + value.toLocaleString()) } // Format Y-axis labels
                    },
                    border: {
                        dash: [10, 10],
                        display: true
                    },
                    grid: {
                        color: "rgba(255, 255, 255, 0.2)"
                    }
                }
            },
            plugins: {
                legend: {
                    display: false // Hide legend (optional)
                }
            }
        }
    });
    payouts_box.style.display = originalDisplay;
}

function UpdateChart(PayoutsPerDate) {
    var labels = [];
    var data = [];
    for (var i = PayoutsPerDate.length - 1; i >= 0; i--) {
        labels.push(PayoutsPerDate[i].Date);
        var val = PayoutsPerDate[i].PayoutsPerDate;
        data.push(val);
    }
    if (myChart) {
        myChart.data.datasets[0].data = data;
        myChart.data.labels = labels;
        myChart.update();
    }
}

function InitPayoutsData(brokerId) {
    const link = '/api/brokers/broker-payouts/' + brokerId;
    var localeCode = window.CURRENT_CULTURE;
    $.ajax({
        url: link,
        data: { fromTime: fromDate, toTime: toDate },
        type: 'GET',
        success: function (res) {
            var localizedTotalPayouts = res.TotalPayouts.toLocaleString(localeCode);
            $("#broker-detail-header-total-payouts").html("$" + res.AllTimeTotalPayouts.toLocaleString(localeCode));
            $("#broker-detail-header-latest-timeout").html(GetTimeString(res.AllTimeLatestPayout, "full"));
            $("#broker-detail-total-payouts").html("$" + localizedTotalPayouts);
            $("#broker-detail-number-of-payouts").html(res.NumberOfPayouts.toLocaleString(localeCode));
            $("#broker-detail-largest-single-payout").html("$" + res.LargestSinglePayout.toLocaleString(localeCode));
            $("#broker-detail-latest-payouts").html(GetTimeString(res.LatestPayout));
            if (!myChart) CreateChart(res.PayoutsPerDate);
            else UpdateChart(res.PayoutsPerDate);
        }
    });
}

function InitPayoutsTab(brokerId) {

    InitPayoutsData(brokerId);
    InitializeBrokerPayoutsTable(brokerId, fromDate, toDate);

    $(document).on('click', '.time-btn', function (e) {
        if ($('.time-btn.active').data('time') == $(e.target).data('time')) return;
        $('.time-btn').removeClass('active');
        var ele = e.target;
        $(ele).addClass('active');
        var val = $(ele).data('time');
        CalcFromAndToDate(val, brokerId);
    });

    $(document).on('change', '#period-select', function (e) {
        var val = e.target.value;
        CalcFromAndToDate(val, brokerId);
    })

    $('#fromdatepicker').datepicker().on('change', function (e) {
        var val = e.target.value;
        if (val == "") {
            fromDate = 0;
        }
        else {
            var date = new Date(val);
            var startOfDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
            fromDate = startOfDay.getTime() / 1000;
        }
        currentPage = 1;
        InitPayoutsData(brokerId);
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate);
    })

    $('#todatepicker').datepicker().on('change', function (e) {
        var val = e.target.value;
        if (val == "") toDate = 0;
        else {
            var date = new Date(val);
            var endOfDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 0));
            toDate = endOfDay.getTime() / 1000;
        }
        currentPage = 1;
        InitPayoutsData(brokerId);
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate);
    });

    $(document).on('click', '.pagination li.pagedList', function (e) {
        var number = Number(e.target.textContent);
        currentPage = number;
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate, number);
    })

    $(document).on('click', '.pagination #PagedList-skipToFirst', function (e) {
        currentPage = 1;
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate, 1);
    })

    $(document).on('click', '.pagination #PagedList-skipToLast', function (e) {
        currentPage = totalPages;
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate, totalPages);
    })

    $(document).on('click', '.pagination #PagedList-skipToPrevious', function (e) {
        currentPage = currentPage - 1;
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate, currentPage - 1);
    })

    $(document).on('click', '.pagination #PagedList-skipToNext', function (e) {
        currentPage = currentPage + 1;
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate, currentPage + 1);
    })

    $(document).on('click', '.pagination #PagedList-prev-ellipses', function (e) {
        currentPage = currentPage - 1;
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate, currentPage - 1);
    })

    $(document).on('click', '.pagination #PagedList-next-ellipses', function (e) {
        currentPage = currentPage + 1;
        InitializeBrokerPayoutsTable(brokerId, fromDate, toDate, currentPage + 1);
    })

}

function CalcFromAndToDate(val, brokerId) {
    const now = new Date();
    const endOfDay = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59, 59, 0));
    switch (val) {
        case "today":
            var startOfDay = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0, 0));
            $('#fromdatepicker').datepicker().value(now.toISOString().split('T')[0]);
            $('#todatepicker').datepicker().value(now.toISOString().split('T')[0]);
            fromDate = startOfDay.getTime() / 1000;
            toDate = endOfDay.getTime() / 1000;
            break;
        case "week":
            const oneWeekAgo = new Date();
            oneWeekAgo.setDate(now.getDate() - 7);
            $('#fromdatepicker').datepicker().value(oneWeekAgo.toISOString().split('T')[0]);
            $('#todatepicker').datepicker().value(now.toISOString().split('T')[0]);
            startOfDay = new Date(Date.UTC(oneWeekAgo.getUTCFullYear(), oneWeekAgo.getUTCMonth(), oneWeekAgo.getUTCDate(), 0, 0, 0, 0));
            fromDate = startOfDay.getTime() / 1000;
            toDate = endOfDay.getTime() / 1000;
            break;
        case "month":
            const oneMonthAgo = new Date();
            oneMonthAgo.setMonth(now.getMonth() - 1);
            $('#fromdatepicker').datepicker().value(oneMonthAgo.toISOString().split('T')[0]);
            $('#todatepicker').datepicker().value(now.toISOString().split('T')[0]);
            startOfDay = new Date(Date.UTC(oneMonthAgo.getUTCFullYear(), oneMonthAgo.getUTCMonth(), oneMonthAgo.getUTCDate(), 0, 0, 0, 0));
            fromDate = startOfDay.getTime() / 1000;
            toDate = endOfDay.getTime() / 1000;
            break;
        case "threeMonths":
            const threeMonthsAgo = new Date();
            threeMonthsAgo.setMonth(now.getMonth() - 3);
            $('#fromdatepicker').datepicker().value(threeMonthsAgo.toISOString().split('T')[0]);
            $('#todatepicker').datepicker().value(now.toISOString().split('T')[0]);
            startOfDay = new Date(Date.UTC(threeMonthsAgo.getUTCFullYear(), threeMonthsAgo.getUTCMonth(), threeMonthsAgo.getUTCDate(), 0, 0, 0, 0));
            fromDate = startOfDay.getTime() / 1000;
            toDate = endOfDay.getTime() / 1000;
            break;
        case "all":
            fromDate = 0;
            toDate = 0;
            InitPayoutsData(brokerId);
            InitializeBrokerPayoutsTable(brokerId, fromDate, toDate);
            $('#fromdatepicker').datepicker().value("");
            $('#todatepicker').datepicker().value("");
            break;
    }
}
function InitializeBrokerPayoutsTable(brokerId, fromTime, toTime) {
    const payoutListLink = '/api/brokers/broker-payouts-list/' + brokerId;
    var localeCode = window.CURRENT_CULTURE;
    $.ajax({
        url: payoutListLink,
        data: { fromTime: fromTime, toTime: toTime, currentPage: currentPage, countPerPage: 100 },
        type: 'GET',
        success: function (res) {
            totalPages = res.TotalPages;
            InitializePayoutsTablePagination(totalPages, currentPage);
            var tbodyHtml = "";
            if (res.Payouts.length == 0) {
                tbodyHtml += '<tr><td colspan="2">No payouts</td></tr>';
            }
            else {
                res.Payouts.forEach(function (payout, i) {
                    tbodyHtml += '<tr>';
                    tbodyHtml += '<td>' + GetTimeString(payout.Time, "full") + '</td>';
                    tbodyHtml += '<td>$ ' + payout.PayoutsPerTime.toLocaleString(localeCode) + '</td>';
                    tbodyHtml += '</tr>';
                });
            }
            $("#broker-detail-payout-table tbody").html(tbodyHtml);
        }
    });
}

function InitializePayoutsTablePagination(totalPages, currentPage) {

    var paginationHtml = "";

    if (totalPages > 4 && currentPage > 3) {
        paginationHtml += '<li class="PagedList-skipToFirst" id="PagedList-skipToFirst"><a><<</a></li>';
    }

    if (currentPage > 1) {
        paginationHtml += '<li class="PagedList-skipToPrevious" id="PagedList-skipToPrevious"><a><</a></li>';
    }

    if (totalPages > 4 && currentPage > 3) {
        paginationHtml += '<li class="PagedList-ellipses" id="PagedList-prev-ellipses"><a>...</a></li>';
    }

    var start = 1;
    if (totalPages > 4) {
        if (currentPage == totalPages) start = currentPage - 3;
        else if (currentPage - 2 > 1) start = currentPage - 2;
    }
    var end = totalPages;
    if (totalPages > 4) {
        if (currentPage <= 3) end = 4;
        else if (currentPage + 1 < totalPages) end = currentPage + 1;
    }
    for (var i = start; i <= end; i++) {
        if (i == currentPage)
            paginationHtml += '<li class="active pagedList"><span>' + i + '</span></li>';
        else paginationHtml += '<li class="pagedList"><a>' + i + '</a></li>';
    }

    if (totalPages > 4 && currentPage < totalPages - 1) {
        paginationHtml += '<li class="PagedList-ellipses" id="PagedList-next-ellipses"><a>...</a></li>';
    }

    if (currentPage < totalPages) {
        paginationHtml += '<li class="PagedList-skipToNext" id="PagedList-skipToNext"><a>></a></li>';
    }

    if (totalPages > 4 && currentPage < totalPages - 1) {
        paginationHtml += '<li class="PagedList-skipToLast" id="PagedList-skipToLast"><a>>></a></li>';
    }

    $(".pagination").html(paginationHtml);
}

function InitNewsTab(brokerId) {
    if ($("#broker-news-paginator").length == 0) {
        return;
    }

    const link = '/api/news/broker-news/' + brokerId;

    $("#broker-news-paginator").pagination({
        dataSource: link,
        locator: 'Data.Data',
        pageSize: 40,
        pageRange: 1,
        className: 'light-pagination paginationjs-small',
        autoHidePrevious: true,
        autoHideNext: true,
        totalNumberLocator: function (response) {
            if (!response) return 0;
            return response.Data.Count;
        },
        callback: function (data, pagination) {
            var langSlug = "";
            if (window.CURRENT_LANG != "en")
                langSlug += "/" + window.CURRENT_LANG;

            if (!pagination.originalResponse.Success) return;

            $("#tab-news a").html(window.NEWS + " (" + pagination.originalResponse.Data.Count + ")");

            var html = '<div class="frn-flex-row flex-column" style="gap: 16px;">';
            for (var i = 0; i < data.length; i++) {
                const news = data[i];

                var logoUrl = '/Content/dist/news/images/no-image';
                if (news.ImportedFromThirdParty && news.Thumbnail) {
                    logoUrl = news.Thumbnail;
                }
                else if (news.Thumbnail) {
                    logoUrl = '/content/dist/news/images/' + news.Thumbnail;
                } else if (news.ListingType) {
                    logoUrl = '/Content/dist/images/PageElements/news-' + news.ListingType + ".png";
                }
                var publishedDays = moment.duration(moment.utc(news.PublishDate).diff(moment.utc())).humanize(true)
                var newsUrl = langSlug + "/news/" + news.NewsSlug + "-" + news.NewsId;

                var tagsHtml = '';
                if (news.Tags) {
                    news.Tags.forEach(function (tag) {
                        if (news.TagLinks[tag]) {
                            tagsHtml += '<a class="tag" href="' + news.TagLinks[tag] +'"><span>' + tag + '</span></a>';
                        } else {
                            tagsHtml += '<div class="tag"><span>' + tag + '</span></div>';
                        }
                        
                    });
                }
                var companyHtml = '';
                if (news.AssociatedBrokerId > 0) {
                    if (news.AssociatedBrokerLogo) {
                        companyHtml += '<img class="image" src="/Content/dist/brokers/images/' + news.AssociatedBrokerLogo + '" alt="' + news.AssociatedBrokerName + '" />';
                    }
                    else {
                        companyHtml += '<img class="image" src="/Content/dist/brokers/images/no-image" alt="' + news.AssociatedBrokerName + '" />';
                    }
                }
                companyHtml += '<span>By ';
                if (news.AuthorSocialProfileId == 0) {
                    companyHtml += '<span>' + news.AuthorName + '</span>';
                } else {
                    companyHtml += '<span class="social-profile-navigate text-dotted-underline" data-profile-id="' + news.AuthorSocialProfileId + '">' + news.AuthorName + '</span>'
                }

                if (news.AssociatedBrokerId > 0) {
                    companyHtml += '<text> at </text><a href="' + langSlug + news.AssociatedBrokerUrl + '">' + news.AssociatedBrokerName + '</a>';
                }
                companyHtml += '</span>';

                var newsArticle = '<div class="news-item-box">' +
                    '<div class="d-flex flex-column" style="gap: 8px;">' +
                        '<div class="d-flex" style="gap: 16px;">' +
                            '<a class="d-none d-md-block" href="' + newsUrl + '">' +
                                '<img class="thumbnail-image" src="' + logoUrl + '" alt="' + news.Title + '">' +
                            '</a>' +
                            '<div class="d-flex flex-column flex-grow-1" style="gap: 8px;">' +
                                '<div class="d-flex justify-content-between align-items-md-center flex-column flex-md-row flex-md-row-reverse">' +
                                    '<div class="d-flex flex-column align-items-end">' +
                                        '<span class="news-date" data-date="' + news.PublishDate + '">' + publishedDays + '</span>' +
                                    '</div>' +
                                    '<div class="d-flex align-items-center" style="gap: 16px;">' + 
                                        '<a class="d-block d-md-none" href="' + newsUrl + '">' +
                                            '<img class="thumbnail-image" src="' + logoUrl + '" alt="' + news.Title + '">' +
                                        '</a>' +
                                        '<div class="d-flex align-items-md-center flex-column flex-md-row flex-md-row-reverse">' +
                                            '<a href="/forum?category=' + news.ForumCategoryId + '" class="news-discussion-link ml-0 ml-md-3">' +
                                                '<div class="discussion-icon">' +
                                                    '<icon class="mdi mdi-forum"></icon>' +
                                                '</div>' +
                                                '<span>' + window.brokerResxStrings['NewsDiscussionForum'] + '</span>' +
                                            '</a>' +
                                            '<div class="broker mt-2 mt-md-0">' +
                                                companyHtml +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<a href="' + newsUrl + '"><div class="title">' + news.Title + '</div></a>' +
                                '<div class="text">' + news.Summary + '</div>' +
                                '<div class="d-flex justify-content-between flex-md-row flex-column" style="gap: 8px;">' +
                                    '<div class="d-flex flex-wrap" style="gap: 8px;">' +
                                        tagsHtml +
                                    '</div>' +
                                    '<div class="d-flex flex-column align-items-end">' +
                                        '<a href="javascript:void(0);" onclick="window.SocialProfile.AddInlineEntityPost(' + news.ForumCategoryId + ', \'NewsPage\', ' + news.NewsId + ')" class="reply">' +
                                            '<i class="reply-to-post"></i>' +
                                            '<span>' + window.brokerResxStrings['Reply'] + '</span>' +
                                        '</a>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>';

                html += newsArticle;
            }

            html += '</div>';
            $('#broker-news-container').html(html);

        }
    });
}

function CheckIfUserNeedOnboarding(brokerId) {

    var manualCookiemsg = window.CookieInstance.GetCookie("CompanyRepOnboardingManualVerificationNeed");

    if (manualCookiemsg) {
        var onboardedCompanyId = window.CookieInstance.GetValue("CompanyId", manualCookiemsg);

        if (onboardedCompanyId == brokerId) {
            $("#company-rep-pending-email-verification").modal('show');
            window.CookieInstance.DeleteCookie("CompanyRepOnboardingManualVerificationNeed");
        }
    }

    var cookieMsg = window.CookieInstance.GetCookie("CompanyRepOnboardingTourNeed")
    if (cookieMsg) {
        var onboardedCompanyId = window.CookieInstance.GetValue("CompanyId", cookieMsg);

        if (onboardedCompanyId == brokerId) {
            $("#broker-widgets-tour-dialog").modal('show');
        }
    }
}

function ScrollToWidgets() {
    var element = document.querySelector('.user-reviews-widgets-content');
    if (element) {
        var y = element.getBoundingClientRect().top + window.scrollY - 50;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
}


function CopyCode(code) {
    navigator.clipboard.writeText(code);
    toastr.success("Copied to clipboard");
}

function ShowPromoCodeDialog(challengeId) {
    const dealContainer = document.getElementById('challenge-promo-code-deal-container-' + challengeId);
    const dialog = document.getElementById('challenge-promo-code-dialog-box-' + challengeId);
    const overlay = document.getElementById('challenge-promo-code-dialog-' + challengeId);
    overlay.style.display = 'block';
    dialog.style.display = 'flex';
    const rect = dealContainer.getBoundingClientRect();
    // Scroll offsets
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    // Position the dialog
    dialog.style.top = (rect.bottom + 2) + 'px';
    if (window.innerWidth > 767) {
        dialog.style.left = (rect.left) + 'px';
    }
    else {
        dialog.style.left = "3vw";
    }
    document.body.style.overflow = "hidden";
}

function ClosePromoCodeDialog(challengeId) {
    const dialog = document.getElementById('challenge-promo-code-dialog-box-' + challengeId);
    const overlay = document.getElementById('challenge-promo-code-dialog-' + challengeId);
    dialog.style.display = 'none';
    overlay.style.display = 'none';
    document.body.style.overflow = "";
}
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _BrokerCompare = _interopRequireDefault(require("../../includes/BrokerCompare.js"));
var _Cookie = _interopRequireDefault(require("../../includes/Cookie.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
$(function () {
  window.BrokerCompare = new _BrokerCompare["default"]();
  window.BrokerCompare.initPopovers(true);
  window.CookieInstance = new _Cookie["default"]();
  $.fn.isInViewport = function (isFully) {
    if ($(this).length == 0) return false;
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    if (isFully === true) return viewportTop <= elementTop && elementBottom <= viewportBottom;
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  $('[data-toggle="normal-popover"]').popover({
    trigger: "manual"
  }).on("mouseenter", function () {
    var _this = this;
    $(this).popover("show");
    $(".popover").on("mouseleave", function () {
      $(_this).popover('hide');
    });
  }).on("mouseleave", function () {
    var _this = this;
    setTimeout(function () {
      if (!$(".popover:hover").length) {
        $(_this).popover("hide");
      }
    }, 100);
  });
  InitializeImageLazyLoading();
});

},{"../../includes/BrokerCompare.js":2,"../../includes/Cookie.js":3}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
  }
  return _createClass(Cookie, [{
    key: "SetCookie",
    value: function SetCookie(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieToExpireInHours",
    value: function SetCookieToExpireInHours(CookieName, CookieValue, ExpiresInHours) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieSameSiteNone",
    value: function SetCookieSameSiteNone(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=None;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetSessionCookie",
    value: function SetSessionCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";Secure;SameSite=Lax;expires=0;path=/";
    }
  }, {
    key: "GetCookie",
    value: function GetCookie(cname) {
      var name = cname + "=";
      var cookie = document.cookie;
      var ca = cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i]);
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }, {
    key: "DeleteCookie",
    value: function DeleteCookie(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  }, {
    key: "GetValue",
    value: function GetValue(requestedValue, data) {
      var nameEQ = requestedValue + "=";
      var splits = data.split("&");
      for (var i = 0; i < splits.length; i++) {
        var c = splits[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
    }
  }]);
}();
var _default = exports["default"] = Cookie;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BrokerCompare = /*#__PURE__*/function () {
  function BrokerCompare() {
    var _this2 = this;
    _classCallCheck(this, BrokerCompare);
    if ($("#accTypeCashbackSelect").length) {
      this.showCashbackRate($("#accTypeCashbackSelect option:first").val());
    }
    $('#show-filter-dialog').on('hidden.bs.modal', function () {
      var searchEle = $('#broker-search').remove();
      searchEle.insertAfter($("#broker-list"));
      _this2.resetSearchColWidth();
    });
    $('#show-filter-dialog').on('show.bs.modal', function () {
      // give a little delay to allow the widths to get set
      setTimeout(function () {
        _this2.resetSearchColWidth();
      }, 300);
    });
    var element = $('div.container.content-pane.page-content.wide-content-pane');

    //console.log($('div.container.content-pane.page-content.wide-content-pane'));
    //$('div.container.content-pane.page-content.wide-content-pane').bind('resize', function () {
    //    alert("bigger")
    //});
    //window.addEventListener("resize", setTimeout(function () {
    //    window.BrokerCompare.resetSearchColWidth();
    //}, 300));
  }
  return _createClass(BrokerCompare, [{
    key: "initPopovers",
    value: function initPopovers() {
      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (update) {
        $('[data-toggle = "pop-overall-rate"]').popover('dispose');
        $('[data-toggle = "pop-rate"]').popover('dispose');
      }
      $('[data-toggle="popover"]').popover({
        html: true,
        trigger: "manual",
        content: function content() {
          var out = "<div class=\"rating-popover-content\">" + $('#hidden-overall-rate').html() + "</div>";
          return out;
        }
      }).on("mouseenter", function () {
        var _this = this;
        $(this).popover("show");
        $(".popover").on("mouseleave", function () {
          $(_this).popover('hide');
        });
      }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
          if (!$(".popover:hover").length) {
            $(_this).popover("hide");
          }
        }, 100);
      });
      $('[data-toggle="pop-pay-opt"]').popover({
        content: function content() {
          var id = $(this).data('target-id');
          var out = "<div class=\"broker-display-payment-options-list\">" + $('#hidden-pay-' + id).html() + "</div>";
          return out;
        }
      });
      $('[data-toggle="pop-rate"]').popover({
        html: true,
        trigger: "manual",
        content: function content() {
          var id = $(this).data('target-id');
          var out = "<div class=\"rating-popover-content\">" + $('#hidden-rate-' + id).html() + "</div>";
          return out;
        }
      }).on("mouseenter", function () {
        var _this = this;
        $(this).popover("show");
        $(".popover").on("mouseleave", function () {
          $(_this).popover('hide');
        });
      }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
          if (!$(".popover:hover").length) {
            $(_this).popover("hide");
          }
        }, 100);
      });
      ;
      $('[data-toggle="pop-supported-languages"]').popover({
        content: function content() {
          var id = $(this).data('target-id');
          var out = $('#hidden-supported-languages-' + id).html();
          return out;
        }
      });
      $('[data-toggle="pop-overall-rate"]').popover({
        html: true,
        trigger: "manual",
        content: function content() {
          var id = $(this).data('target-id');
          var out = "<div class=\"rating-popover-content\">" + $('#hidden-overall-rate-' + id).html() + "</div>";
          return out;
        }
      }).on("mouseenter", function () {
        var _this = this;
        $(this).popover("show");
        setTimeout(function () {
          $('.popover [data-toggle=tooltip]').tooltip('dispose').tooltip({
            boundary: 'window'
          });
        }, 100);
        $(".popover").on("mouseleave", function () {
          $(_this).popover('hide');
        });
      }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
          if (!$(".popover:hover").length) {
            $(_this).popover("hide");
            $(".tooltip").remove();
          }
        }, 100);
      });
      $('[data-toggle="pop-rebate-description"]').popover({
        html: true,
        trigger: "manual",
        container: 'body',
        content: function content() {
          var id = $(this).data('target-id');
          var out = "<div class=\"rating-popover-content\">" + $('#hidden-description-' + id).html() + "</div>";
          return out;
        }
      }).on("mouseenter", function () {
        var _this = this;
        $(this).popover("show");
        $(".popover").on("mouseleave", function () {
          $(_this).popover('hide');
        });
      }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
          if (!$(".popover:hover").length) {
            $(_this).popover("hide");
          }
        }, 100);
      });
      ;
    }
  }, {
    key: "showCashbackRate",
    value: function showCashbackRate(id) {
      if ($('.accTypeSelect').length) {
        $('.accTypeSelect').val(id);
        $('.compact-view').removeClass('active-table');
        $('.compact-view-' + id).addClass('active-table');
      }
    }
  }, {
    key: "resetSearchColWidth",
    value: function resetSearchColWidth() {
      var width = $('#broker-search .dropdown.faux-multi-select-wrap').first().width();
      $('#broker-search .dropdown.faux-multi-select-wrap .frn-dropdown-menu').css('maxWidth', width);
      $('#broker-search .dropdown.faux-multi-select-wrap .selected-options').css('maxWidth', width);
    }
  }, {
    key: "showFilterDialog",
    value: function showFilterDialog() {
      var searchEle = $('#broker-search').remove();
      searchEle.appendTo('#show-filter-dialog-body');
      $('#show-filter-dialog').modal('show');
    }
  }]);
}();
var _default = exports["default"] = BrokerCompare;

},{}]},{},[1]);
